// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for FR
 * @file translations.fr.js
 * @description Main application translations for fr
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsFr = {
                'login.title': 'Connexion',
                'login.slogan': 'Conversations sans frontières !',
                'login.username': 'Nom d\'utilisateur',
                'login.password': 'Mot de passe',
                'login.submit': 'Se connecter',
                'login.loading': 'Chargement...',
                'login.autoRegister.title': 'Inscription automatique',
                'login.autoRegister.description': 'Si vous n\'avez pas de compte, entrez votre nom d\'utilisateur et mot de passe. Il sera créé automatiquement.',
                'login.forgotPassword': 'Mot de passe oublié ?',
                'login.passwordRecovery.title': 'Récupérer le mot de passe',
                'login.passwordRecovery.description': 'Entrez votre email pour recevoir un lien de récupération.',
                "login.passwordRecovery.emailLabel": "E-mail",
                'login.passwordRecovery.emailPlaceholder': 'Entrez votre email',
                'login.passwordRecovery.emailHelp': 'Un lien de récupération sera envoyé à votre email',
                'login.passwordRecovery.send': 'Envoyer',
                'login.passwordRecovery.success': 'Un lien de récupération a été envoyé à votre email. Vérifiez votre boîte de réception.',
                'login.passwordRecovery.successTitle': 'E-mail envoyé',
                'login.passwordRecovery.successMessage': 'Nous vous avons envoyé un e-mail avec les instructions pour réinitialiser votre mot de passe.\nVérifiez votre boîte de réception et les courriers indésirables. Le lien peut prendre quelques minutes.',
                'login.passwordRecovery.devExplanation': 'En mode développement, l\'e-mail n\'est pas envoyé à votre boîte ; il est enregistré pour prévisualisation. Utilisez « Voir l\'e-mail » pour afficher le contenu et le lien de récupération.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Mode développement : cet e-mail n\'a PAS été envoyé à votre boîte. Utilisez « Voir l\'e-mail » pour ouvrir le message généré et le lien.',
                'login.passwordRecovery.invalidEmail': 'Veuillez entrer une adresse email valide',
                'login.error.invalidPassword': 'Mot de passe invalide',
                'common.language': 'Langue',
                'common.loading': 'Chargement…',
                'common.back': 'Retour',
                'common.backToStart': 'Retour à l\'accueil',
                'common.changeUser': 'Changer d\'utilisateur',
                'common.request_id_label': 'ID de demande',
                'login.email.invalid': 'Veuillez entrer un email valide',
                'captcha.solve': 'Veuillez résoudre le CAPTCHA correctement',
                'captcha.generateError': 'Erreur lors de la génération du CAPTCHA. Veuillez recharger la page.',
                'auth.require_email': 'L\'email est requis pour terminer l\'inscription. Veuillez entrer votre email.',
                'auth.invalid_credentials': 'Identifiant ou mot de passe incorrect.',
                'auth.account_blocked': 'Compte inactif. Entrez votre email pour le réactiver.',
                'auth.device_limit_reached': 'Limite d\'appareils atteinte. Déconnectez-vous sur un autre appareil ou améliorez votre plan.',
                'auth.login.device_limit.title': 'Limite de sessions ou d\'appareils atteinte',
                'auth.login.device_limit.body': 'Votre forfait autorise un nombre limité de sessions ou d\'appareils actifs en même temps. Pour vous connecter, déconnectez-vous sur un autre appareil ou fermez une autre session active, puis réessayez.',
                'auth.password_incorrect': 'Le mot de passe est incorrect.',
                'auth.login.password_error_title': 'Mot de passe incorrect',
                'auth.login.password_attempts_hint': 'Vous avez 3 tentatives pour saisir correctement votre mot de passe. Si vous les dépassez, vous devrez réinitialiser votre mot de passe.',
                'auth.login.password_attempts_exhausted_title': 'Limite de tentatives atteinte',
                'auth.login.password_attempts_exhausted_body': 'Vous avez dépassé les 3 tentatives autorisées. Pour continuer, réinitialisez votre mot de passe via « Mot de passe oublié ? ».',
                'auth.login.go_to_reset_password': 'Aller à la réinitialisation',
                'auth.login.password_remaining_two': 'Il vous reste 2 tentatives.',
                'auth.login.password_remaining_one': 'Il vous reste 1 tentative.',
                'auth.login.password_attempts_locked_inline': 'Nombre maximum de tentatives atteint. Vous devez réinitialiser votre mot de passe.',
                'auth.account_inactive_email_mismatch': 'Compte inactif et l\'email ne correspond pas.',
                'auth.captcha_failed': 'CAPTCHA incorrect. Vérifiez votre réponse.',
                'auth.captcha_expired': 'Votre vérification a expiré. Une nouvelle a été générée automatiquement.',
                'auth.unauthorized': 'Vous n\'avez pas la permission d\'accéder.',
                'auth.generic_error': 'Une erreur s\'est produite. Veuillez réessayer.',
                'auth.method_not_allowed': 'Méthode non autorisée.',
                'auth.invalid_data': 'Données invalides.',
                'auth.credentials_required': 'Identifiant et mot de passe requis.',
                'auth.csrf_invalid': 'Session invalide. Rechargez la page et réessayez.',
                'auth.username_taken': 'Ce pseudo est déjà enregistré. Connectez-vous ou choisissez un autre.',
                'auth.username_unavailable': 'Ce pseudo n\'est pas disponible.',
                'auth.nick_no_spaces': 'Le pseudo ne peut pas contenir d\'espaces.',
                'auth.password_too_short': 'Le mot de passe doit contenir au moins 6 caractères.',
                'auth.rate_limit': 'Trop de tentatives. Attendez un moment et réessayez.',
                'auth.confirm_success': 'Compte confirmé avec succès. Redirection vers la connexion...',
                'auth.confirm_already_active': 'Votre compte est déjà actif. Vous pouvez vous connecter.',
                'auth.reset_sent': 'Si l\'email est enregistré, vous recevrez les instructions pour réinitialiser votre mot de passe.',
                'auth.reset_token_invalid': 'Lien invalide ou manquant.',
                'auth.reset_token_expired': 'Ce lien a expiré. Demandez-en un nouveau via "Mot de passe oublié?".',
                'auth.reset_done': 'Mot de passe mis à jour. Vous pouvez vous connecter.',
                'auth.reset_fatal': 'Erreur lors de l\'enregistrement. Réessayez plus tard.',
                'auth.password_mismatch': 'Les mots de passe ne correspondent pas.',
                'resetPassword.page.title': 'Nouveau mot de passe',
                'resetPassword.page.description': 'Entrez votre nouveau mot de passe (au moins 6 caractères).',
                'resetPassword.newPassword': 'Nouveau mot de passe',
                'resetPassword.newPasswordPlaceholder': 'Au moins 6 caractères',
                'resetPassword.submit': 'Réinitialiser le mot de passe',
                'resetPassword.success': 'Mot de passe mis à jour. Redirection vers la connexion...',
                'resetPassword.backToLogin': 'Retour à la connexion',

                'account.delete.section_title': 'Supprimer le compte',
                'account.delete.description': 'La suppression de votre compte supprimera définitivement toutes vos données, messages, contacts et paramètres. Cette action est irréversible.',
                'account.delete.button': 'Supprimer mon compte',
                'accountDeletion.title': 'Suppression du compte et des données',
                'accountDeletion.description': 'Demandez la suppression de votre compte ArChat et des données associées.',
                'accountDeletion.openRequest': 'Demander la suppression du compte et des données',
                'account.delete.confirm_title': 'Supprimer le compte',
                'account.delete.confirm_message': 'Voulez-vous vraiment supprimer votre compte ? Un e-mail de confirmation sera envoyé dans votre boîte de réception. La suppression est définitive et irréversible.',
                'account.delete.email_sent_title': 'E-mail envoyé',
                'account.delete.email_sent': 'Nous vous avons envoyé un e-mail de confirmation. Vérifiez votre boîte de réception et cliquez sur le lien pour confirmer la suppression.',
                'account.delete.error': 'Impossible de traiter la demande. Veuillez réessayer.',
                'account.delete.confirm_page_title': 'Confirmer la suppression du compte',
                'account.delete.confirm_page_desc': 'Vous êtes sur le point de supprimer définitivement votre compte ArChat. Toutes vos données, messages, contacts et paramètres seront supprimés. Cette action est irréversible.',
                'account.delete.confirm_final_button': 'Oui, supprimer définitivement mon compte',
                'account.delete.cancel_go_back': 'Annuler et revenir',
                'account.delete.done_title': 'Compte supprimé',
                'account.delete.done_message': 'Votre compte a été supprimé avec succès. Toutes vos données ont été effacées.',
                'account.delete_token_expired': 'Le lien de suppression a expiré ou n\'est plus valide. Demandez-en un nouveau depuis votre profil.',
                'account.delete_token_invalid': 'Lien de suppression invalide ou manquant.',
                'account.delete_email_failed': 'Impossible d\'envoyer l\'e-mail de confirmation. Réessayez plus tard.',
                'account.delete_error': 'Erreur lors de la suppression. Réessayez plus tard.',

                'auth.register_success_email_sent': 'Compte créé avec succès. Un e-mail de confirmation a été envoyé. Vérifiez votre boîte de réception (et les spams) et cliquez sur le lien pour activer votre compte.',
                'auth.register_success_email_pending': 'Compte créé avec succès, mais l\'envoi de l\'e-mail de confirmation a échoué. Le jeton d\'activation reste valide. Contactez l\'administrateur ou demandez un nouvel e-mail de confirmation.',
                'auth.email_not_verified': 'Vous devez confirmer votre e-mail pour activer le compte.',
                'auth.email_not_verified_title': 'Compte en attente de confirmation',
                'auth.email_send_failed': 'Impossible d\'envoyer l\'e-mail pour le moment. Réessayez ou changez l\'e-mail.',
                'auth.email_send_failed_title': 'Impossible d\'envoyer l\'e-mail',
                'auth.register.email_failed.title': 'Compte créé',
                'auth.register.email_failed.message': 'Votre compte a été créé avec succès, mais un problème est survenu lors de l\'envoi de l\'e-mail de confirmation. Vérifiez les spams ou demandez un nouvel e-mail.',
                'auth.register.success.title': 'Compte créé',
                'auth.register.success.message': 'Compte créé avec succès. Un e-mail de confirmation a été envoyé. Vérifiez votre boîte de réception (et les spams) et cliquez sur le lien pour activer votre compte.',
                'auth.resend_sent': 'E-mail de confirmation renvoyé.',
                'auth.resend_email': 'Renvoyer l\'e-mail',
                'auth.retry_resend': 'Réessayer',
                'auth.change_email': 'Changer l\'e-mail',
                'auth.ver_email': 'Voir l\'e-mail',
                'auth.already_verified': 'Le compte est déjà vérifié.',
                'auth.confirm_email_title': 'Confirmer l\'email',
                'auth.confirm_email_text': 'Le lien d\'activation sera envoyé à :',
                'auth.confirm_email_edit': 'Modifier',
                'auth.confirm_email_confirm': 'Confirmer',
                'auth.confirm_email_typo_hint': 'Vouliez-vous dire ***@{suggestion} ?',
                'brand.slogan': 'Le pouvoir d\'être compris, quelle que soit la langue',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'Le pouvoir d\'être compris, quelle que soit la langue',
                'home.tagline': 'Messagerie avec traduction automatique',
                'home.login': 'Se connecter',
                'home.register': 'Créer un compte',
                'home.language': 'Langue',
                'terms.title': 'Conditions générales',
                'terms.accept': 'Accepter et continuer',
                'terms.reject': 'Rejeter',
                'terms.rejectShort': 'Je n\'accepte pas',
                'terms.readAndAccept': 'J\'ai lu et j\'accepte les conditions générales',
                'terms.cancel': 'Annuler',
                'register.pageTitle': 'Créer un compte',
                'register.pageSubtitle': 'Renseignez vos informations pour créer votre compte.',
                'register.submitLabel': 'Créer un compte',
                'register.confirm_title': 'Confirmer le compte',
                'register.confirm_message': 'Vous êtes sur le point de créer le compte :',
                'register.confirm': 'Confirmer',
                'register.login_link': 'Vous avez déjà un compte ?',
                'register.password_hint': 'Minimum 6 caractères',
                'register.checking': 'Vérification…',
                'register.username_taken': 'Ce nom d\'utilisateur est déjà utilisé.',
                "register.available": "Disponible",
                'register.emailAlreadyExists': 'Cet e-mail est déjà enregistré.',
                'register.continue': 'Continuer',
                'login.demo.title': 'Accès démo',
                'login.demo.credentials': 'Utilisateur: demo / Mot de passe: demo',
                'captcha.label': 'Vérification de sécurité',
                'security.verification_title': 'Vérification de sécurité',
                'security.captcha_question': 'Question de vérification',
                'security.enter_answer': 'Saisissez la réponse',
                'captcha.description': 'Résolvez l\'opération mathématique pour vérifier que vous êtes humain',
                'captcha.required': 'Vous devez saisir la réponse du CAPTCHA pour continuer.',
                "menu.conversations": "Conversations",
                'menu.contacts': 'Carnet',
                'menu.dashboard': 'Tableau de bord',
                'menu.profile': 'Mon profil',
                'menu.settings': 'Paramètres',
                'menu.help': 'Aide',
                'menu.logout': 'Déconnexion',
                'menu.files': 'Mes fichiers',
                'reviews.menu_title': 'Avis',
                'reviews.rate_archat': 'Noter ArChat',
                'reviews.my_review': 'Mon avis',
                "navbar.contacts": "Contacts",
                'navbar.profile': 'Mon profil',
                'navbar.settings': 'Paramètres',
                'navbar.logout': 'Déconnexion',
                'navbar.status': 'Statut',
                'navbar.users': 'Utilisateurs',
                'navbar.no_blocked_users': 'Aucun utilisateur bloqué',
                'navbar.blocked_users_title': 'Utilisateurs bloqués',
                'contacts.blocked_users_title': 'Utilisateurs bloqués',
                'contacts.country_label': 'Pays',
                'contacts.not_reported': 'Non renseigné',
                'navbar.user_fallback': 'Utilisateur {id}',
                'onboarding.welcome_title': 'Bienvenue sur ArChat®',
                'onboarding.welcome_subtitle': 'Communiquez avec n’importe qui dans n’importe quelle langue.',
                'onboarding.step1': 'Étape 1',
                'onboarding.step1_title': 'Étape 1',
                'onboarding.step1_description': 'Invitez votre premier contact',
                'onboarding.step2': 'Étape 2',
                'onboarding.step2_title': 'Étape 2',
                'onboarding.step2_description': 'Envoyez votre premier message',
                'onboarding.invite_contact': 'Inviter un contact',
                'onboarding.explore_archat': 'Explorer ArChat®',
                'contacts.invite_contact': 'Inviter un contact',
                'contacts.no_contacts': 'Aucun contact',
                'help.view_initial_guide': 'Voir le guide initial',
                "suggestions.title": "Suggestions",
                'suggestions.form.title': 'Titre de la suggestion',
                'suggestions.form.message': 'Décrivez votre idée',
                'suggestions.form.submit': 'Envoyer la suggestion',
                'suggestions.send': 'Envoyer la suggestion',
                'suggestions.captcha_placeholder': 'Résultat',
                'suggestions.cooldown': 'Vous devez attendre {minutes} minutes avant d\'envoyer une autre suggestion.',
                'suggestions.success_title': 'Suggestion envoyée',
                'suggestions.success_message': 'Votre suggestion a été envoyée avec succès. Numéro de suivi : {id}',
                'suggestions.success': 'Merci pour votre suggestion. Notre équipe l\'examinera.',
                'suggestions.success.title': 'Merci pour votre suggestion !',
                'suggestions.success.reference': 'Référence',
                'suggestions.success.review': 'Notre équipe examinera votre idée.',
                'suggestions.success.email': 'Nous vous avons également envoyé un email de confirmation.',
                'suggestions.success.copy': 'Copier',
                'suggestions.success.copied': 'Référence copiée',
                'suggestions.form.required': 'Le titre et le message sont obligatoires.',
                'suggestions.error': 'Envoi impossible. Veuillez réessayer.',
                'profile.title': 'Mon profil',
                'profile.founderBadge': 'Fondateur #{position}/{limit}',
                'profile.founderTooltip': 'Membre Fondateur – Prix gelé à vie tant que l\'abonnement reste actif',
                'profile.founderMember': 'Membre Fondateur',
                'profile.founderHeaderBadge': '★ Fondateur #{position}/150',
                'profile.camera.access_denied': 'Impossible d\'accéder à la caméra. Vérifiez les autorisations.',
                'profile.edit': 'Modifier',
                'profile.save': 'Enregistrer les modifications',
                'profile.save.success': 'Votre profil a été mis à jour avec succès.',
                'profile.save.success.title': 'Profil Mis à Jour',
                'profile.update.success.title': 'Profil Mis à Jour',
                'profile.update.success.message': 'Vos modifications ont été enregistrées.',
                'profile.save.error': 'Impossible de mettre à jour le profil. Veuillez réessayer.',
                'profile.save.error.title': 'Erreur de Sauvegarde',
                'profile.cancel': 'Annuler',
                'profile.nick': 'Nom d\'utilisateur',
                'profile.nick.help': 'Votre identifiant unique dans le système',
                'profile.nick.readonly': 'Le nom d\'utilisateur ne peut pas être modifié',
                'profile.nick.readonly.help': 'Le nom d\'utilisateur est unique et ne peut pas être modifié',
                'profile.email.readonly': 'L\'email ne peut pas être modifié',
                'profile.email.readonly.help': 'L\'email est unique et ne peut pas être modifié',
                'profile.name': 'Nom réel',
                'profile.lastname': 'Nom',
                "profile.alias": "Alias",
                "profile.email": "E-mail",
                'profile.phone': 'Téléphone',
                'profile.language': 'Langue',
                'profile.country': 'Pays',
                'profile.country.select': 'Sélectionner le pays',
                'profile.biography': 'Biographie',
                "bio.modal.original": "Original",
                'bio.modal.translation': 'Traduction',
                'bio.modal.empty': 'Ce contact n\'a pas de biographie.',
                'bio.modal.translating': 'Traduction en cours...',
                'bio.modal.translation_error': 'Impossible de traduire la biographie.',
                'attachment.unnamed_file': 'Fichier',
                'auth.login_error.default_title': 'Erreur d\'accès',
                'auth.login_error.default_message': 'Connexion impossible.',
                'profile.photo': 'Photo de profil',
                "notifications.bell.aria": "Notifications",
                "notifications.panel.title": "Notifications",
                'notifications.empty': 'Aucune notification',
                'notifications.mark_read': 'Marquer comme lu en ouvrant',
                'profile.notifications.sound': 'Son des notifications',
                'profile.notifications.sound_desc': 'Jouer un son à l\'arrivée de messages ou d\'alertes importantes',
                'profile.plan.expires': 'Expire le',
                'profile.plan.loading_info': 'Chargement des informations du plan...',
                'profile.plan.valid_until': 'Valide jusqu\'au :',
                'profile.plan.active_since': 'Actif depuis :',
                'profile.plan.active_badge': '✓ Actif',
                'profile.plan.upgrade.button': 'Passer à PRO',
                'profile.plan.upgrade.hint': 'Accédez à toutes les fonctionnalités sans limites',
                'billing.change_plan': 'Changer de plan',
                'billing.usage.title': 'Utilisation du plan',
                'billing.usage.users': 'Utilisateurs',
                'billing.usage.messages': 'Messages (aujourd\'hui)',
                'billing.usage.invitations': 'Invitations (aujourd\'hui)',
                'billing.usage.messages_month': 'Messages ce mois',
                "billing.usage.chats": "Conversations",
                'billing.usage.warning': 'Vous approchez de la limite de votre plan. Passez à PRO pour plus de capacité.',
                'plans.limit.reached': 'Limite atteinte — Améliorer le plan',
                'profile.theme.dark': 'Mode Sombre',
                'profile.theme.light': 'Mode Clair',
                'profile.theme.argentina': 'Thème Argentine',
                'modal.title': 'Titre',
                'modal.success.title': 'Succès',
                'modal.error.title': 'Erreur',
                'modal.warning.title': 'Avertissement',
                "info.title": "Information",
                'appearance.title': 'Apparence',
                'appearance.theme.light': 'Clair',
                'appearance.theme.dark': 'Sombre',
                'theme.title': 'Thème',
                'theme.light': 'Clair',
                'theme.dark': 'Sombre',
                'profile.photo.section': 'Photo de profil',
                'profile.personalInfo': 'Informations personnelles',
                'profile.preferences': 'Préférences',
                'profile.photo.change': 'Changer la photo de profil',
                'message.placeholder': 'Écrire un message...',
                'message.placeholderWithFile': 'Envoyer le fichier',
                'message.sent_from_country': 'Envoyé depuis',
                'message.sent_at_local_time': 'Heure locale de l\'expéditeur',
                'message.timezone_label': 'Fuseau horaire',
                'message.context_info': 'Ce message conserve le contexte horaire du moment de l\'envoi.',
                'message.context_pro_hint': 'Ce message inclut le contexte horaire et géographique de l\'expéditeur dans les plans Pro.',
                'message.context_pro_badge': 'Contexte Pro',
                'message.audio.transcribe': 'Transcrire l’audio',
                'message.audio.transcribing': 'Transcription en cours...',
                'message.audio.transcription': 'Transcription',
                'message.audio.error': 'Impossible de transcrire l’audio',
                'attachment.title': 'Joindre un fichier',
                'attachment.close': 'Fermer',
                'attachment.gallery': 'Galerie photos/vidéos',
                'attachment.cameraFront': 'Caméra frontale',
                'attachment.cameraBack': 'Caméra arrière',
                'attachment.cameraWeb': 'Caméra web',
                'attachment.selectFile': 'Sélectionner fichier (PDF, texte, images, vidéos)',
                'attachment.remove': 'Supprimer',
                'attachments.recipientFreeBlocked.title': 'Limite du forfait',
                'attachments.recipientFreeBlocked.sender': 'Cet utilisateur est sur l’offre Free et ne peut pas recevoir de pièces jointes.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} a tenté de vous envoyer une pièce jointe, mais votre offre {planName} n’autorise pas les pièces jointes. Passez à une offre supérieure pour recevoir des fichiers.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Améliorer l’offre',
                'attachment.audioNotSupported': 'Les messages audio ne sont pas compatibles avec ArChat®. Veuillez envoyer un message écrit.',
                'message.audioDeprecated.title': 'Message vocal non compatible',
                'message.audioDeprecated.message': 'Ce message vocal n\'est plus compatible avec ArChat®. Veuillez envoyer un message écrit.',
                'camera.title': 'Caméra',
                'camera.close': 'Fermer',
                'camera.switch': 'Changer de caméra',
                'camera.capture': 'Prendre Photo',
                'camera.loading': 'Démarrage de la caméra...',
                'camera.retry': 'Réessayer',
                'camera.error.access': 'Impossible d\'accéder à la caméra. Vérifiez les permissions.',
                'camera.error.permission': 'Permissions de la caméra refusées. Veuillez autoriser l\'accès à la caméra dans les paramètres du navigateur.',
                'camera.error.notFound': 'Aucune caméra trouvée.',
                'camera.error.busy': 'La caméra est utilisée par une autre application.',
                'camera.error.constraint': 'Les contraintes de la caméra ne peuvent pas être satisfaites.',
                'profile.photo.take': 'Prendre une photo',
                'profile.photo.gallery': 'Choisir dans la galerie',
                'profile.photo.select': 'Sélectionner une photo',
                'profile.photo.select.gallery': 'Choisir dans la galerie',
                'profile.photo.uploading': 'Téléchargement de l\'image...',
                'profile.photo.upload.success': 'Photo de profil mise à jour avec succès',
                'profile.photo.upload.success.title': 'Photo Mise à Jour',
                'profile.photo.upload.error': 'Erreur lors du téléchargement de la photo de profil. Veuillez réessayer.',
                'profile.photo.upload.error.title': 'Erreur de Téléchargement',
                'profile.photo.take.front': 'Caméra frontale',
                'profile.photo.take.back': 'Caméra arrière',
                "profile.photo.take.webcam": "webcam",
                'profile.photo.capture': 'Capturer',
                'profile.country.help': 'Le fuseau horaire sera automatiquement attribué selon le pays sélectionné',
                'profile.lastname.placeholder': 'Votre nom (optionnel)',
                'profile.name.placeholder': 'Votre nom réel (optionnel)',
                'profile.biography.placeholder': 'Parlez-nous de vous...',
                'profile.plan.title': 'Plan d\'Abonnement',
                'profile.plan.current': 'Plan Actuel',
                'profile.plan.free.description': 'Plan gratuit avec limitations. Passez à PRO pour un accès complet.',
                'profile.plan.pro.description': 'Vous avez un accès complet à toutes les fonctionnalités.',
                'user.default': 'Utilisateur',
                'logout.title': 'Confirmer',
                'logout.confirm': 'Êtes-vous sûr de vouloir vous déconnecter?',
                'contacts.title': 'Carnet',
                'contacts.search': 'Rechercher un contact',
                'contacts.search.placeholder': 'Rechercher par nom d\'utilisateur, nom, prénom, pays ou langue...',
                'contacts.sort': 'Trier',
                'contacts.sortByName': 'Par nom',
                'contacts.sortByStatus': 'Par statut',
                'contacts.sortByRecent': 'Plus récents',
                'contacts.filter': 'Filtrer',
                'contacts.filterAll': 'Tous',
                "contacts.filterAvailable": "Disponible",
                'contacts.filterInvited': 'Invités',
                'contacts.filterBlocked': 'Bloqués',
                'contacts.pending_invitations': 'Invitations en attente',
                'contacts.status.invitation_sent': 'Invitation envoyée',
                'contacts.empty': 'Aucun contact',
                'contacts.empty.title': 'Vous n\'avez pas encore de contacts',
                'contacts.empty.message': 'Invitez ou ajoutez-en un pour commencer à discuter.',
                'contacts.empty.invite_button': 'Inviter un contact',
                'contacts.empty.private.message': 'Votre profil est privé. Invitez des contacts pour commencer à discuter.',
                'contacts.empty.private.invite_button': 'Inviter un contact',
                'contacts.search.no_results': 'Aucun contact trouvé',
                'contacts.search.clear': 'Afficher tous',
                'contacts.controls.search_placeholder': 'Rechercher un contact...',
                'contacts.controls.search_label': 'Rechercher un contact',
                'contacts.controls.sort_label': 'Trier par',
                'contacts.controls.sort.name': 'Nom',
                'contacts.controls.sort.status': 'Statut',
                'contacts.controls.sort.recent': 'Récent',
                'contacts.controls.sort.manual': 'Manuel',
                'contacts.controls.sort.manual_drag_hint': 'Glisser pour réorganiser',
                'contacts.controls.filter_label': 'Statut',
                'contacts.controls.filter.all': 'Tous',
                "contacts.controls.filter.available": "Disponible",
                'contacts.controls.filter.invited': 'Invités',
                'contacts.controls.filter.blocked': 'Bloqués',
                'contacts.controls.filter.favorites': 'Favoris',
                'contacts.nick': 'Nom d\'utilisateur',
                'contacts.name': 'Prénom',
                'contacts.lastname': 'Nom',
                'contacts.country': 'Pays',
                'contacts.language': 'Langue',
                'contacts.status': 'Statut',
                "status.available": "Disponible",
                'status.busy': 'Occupé',
                'status.in_call': 'En appel',
                'status.away': 'Absent',
                'status.offline': 'Hors ligne',
                'status.custom': 'Message personnalisé',
                'status.set_title': 'État de disponibilité',
                'status.set_button': 'Changer l\'état',
                'status.placeholder': 'Message optionnel (ex: En réunion)',
                'contacts.status.pending_registration': 'En attente d\'inscription',
                'contacts.status.registered': 'Invité - Inscrit',
                'contacts.status.ready_to_chat': 'Prêt à discuter',
                'contacts.status.active_conversation': 'Conversation active',
                'contacts.invitation.pending.title': 'Invitation en Attente',
                'contacts.invitation.pending.message': 'Cette invitation est en attente d\'inscription. Le contact recevra un email pour compléter son inscription. Une fois inscrit, vous pourrez discuter avec lui.',
                'contacts.error.no_registered': 'Le contact n\'est pas encore inscrit. Attendez qu\'il complète son inscription.',
                'contact.edit.title': 'Modifier le contact',
                'contact.edit.alias.label': 'Alias personnalisé',
                'contact.edit.alias.placeholder': 'Ex: Jean du travail',
                'contact.edit.alias.help': 'Ce nom apparaîtra à la place du nom réel',
                'contact.edit.nota.label': 'Note personnelle',
                'contact.edit.nota.placeholder': 'Ajoutez une note sur ce contact...',
                'contact.edit.nota.help': 'Notes privées visibles uniquement par vous',
                'contact.edit.error.noUser': 'Erreur: Utilisateur non identifié',
                'contact.edit.error.noContactId': 'Erreur: Impossible d\'identifier le contact',
                'contact.edit.error.save': 'Erreur lors de l\'enregistrement',
                'contact.limit.title': 'Limite de contacts atteint',
                'contact.limit.message': 'Le plan FREE autorise jusqu\'à 2 contacts par utilisateur. Passez à FOUNDATION ou PRO pour plus de capacité lorsque la facturation sera activée.',
                'contact.edit.info.personalized': 'Ces modifications sont personnalisées uniquement pour vous et n\'affectent pas les autres utilisateurs.',
                'contact.edit.profileInfo': 'Informations du Profil',
                'export.title': 'Exporter la Conversation',
                'export.description': 'Sélectionnez le format dans lequel vous souhaitez exporter cette conversation:',
                'export.progress': 'Exportation...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'Document PDF avec toutes les images et fichiers',
                "export.format.html": "HTML",
                'export.format.html.description': 'Fichier HTML que vous pouvez ouvrir dans n\'importe quel navigateur',
                'export.info': 'L\'exportation inclura tous les messages, images et fichiers de cette conversation.',
                'export.pro_required.title': 'Exporter la conversation',
                'export.pro_required.message': 'Cette fonctionnalité est disponible avec le plan PRO.',
                'invitation.title': 'Inviter un Contact par Email',
                'invitation.modal.title': 'Envoyer une Invitation',
                'invitation.modal.description': 'Invitez quelqu\'un à discuter avec vous sur ArChat®. Il recevra un email avec un lien pour accepter l\'invitation.',
                'invitation.email.label': 'Email de l\'Invité',
                'invitation.email.placeholder': 'exemple@email.com',
                'invitation.email.required': 'L\'email est obligatoire',
                'invitation.email.invalid': 'Veuillez entrer un email valide',
                'invitation.language.label': 'Langue Préférée de l\'Invité',
                'invitation.language.help': 'L\'email sera envoyé dans cette langue',
                'invitation.mode.label': 'Mode de Conversation',
                'invitation.mode.profesional': 'Professionnel',
                'invitation.mode.profesional.description': 'Conversation formelle et professionnelle',
                'invitation.mode.tecnico': 'Technique',
                'invitation.mode.tecnico.description': 'Conversation technique et spécialisée',
                'invitation.mode.casual': 'Décontracté',
                'invitation.mode.casual.description': 'Conversation informelle et amicale',
                'invitation.message.label': 'Message Personnel (optionnel)',
                'invitation.message.placeholder': 'Écrivez un message personnel pour l\'invité...',
                'invitation.send': 'Envoyer l\'Invitation',
                'invitation.sending': 'Envoi en cours...',
                'invitation.success': 'Invitation envoyée avec succès',
                'invitation.error': 'Erreur lors de l\'envoi de l\'invitation',
                'invitation.error.self': 'Vous ne pouvez pas vous inviter vous-même',
                'invitation.error.duplicate': 'Une invitation en attente existe déjà pour cet email',
                'invitation.list.title': 'Invitations Envoyées',
                'invitation.list.empty': 'Vous n\'avez envoyé aucune invitation',
                "invitation.list.email": "E-mail",
                'invitation.list.language': 'Langue',
                "invitation.list.mode": "Mode",
                'invitation.list.status': 'Statut',
                'invitation.list.created': 'Envoyée',
                'invitation.list.expires': 'Expire',
                "invitation.list.actions": "Actes",
                'invitation.status.pending': 'En attente',
                'invitation.status.accepted': 'Acceptée',
                'invitation.status.expired': 'Expirée',
                'invitation.status.cancelled': 'Annulée',
                'invitation.copy.link': 'Copier le Lien',
                'invitation.copy.success': 'Lien copié dans le presse-papiers',
                'invitation.cancel': 'Annuler',
                'invitation.cancel.confirm': 'Êtes-vous sûr de vouloir annuler cette invitation?',
                'invitation.cancel.success': 'Invitation annulée avec succès',
                'invitation.cancel.title': 'Confirmer l\'Annulation',
                'invitation.resend': 'Renvoyer l\'email',
                'invitation.resend.title': 'Renvoyer l\'Invitation',
                'invitation.resend.success': 'Email d\'invitation renvoyé avec succès',
                'invitation.resend.error': 'Erreur lors du renvoi de l\'email d\'invitation',
                'invitation.accept.title': 'Accepter l\'Invitation',
                'invitation.accept.description': 'Vous avez été invité à discuter sur ArChat®',
                'invitation.accept.inviter': 'Invité par',
                'invitation.accept.message': 'Message personnel',
                'invitation.accept.login': 'Se Connecter',
                'invitation.accept.register': 'S\'inscrire',
                'invitation.accept.error.invalid': 'Token d\'invitation invalide',
                'invitation.accept.error.expired': 'Cette invitation a expiré',
                'invitation.accept.error.accepted': 'Cette invitation a déjà été acceptée',
                'invitation.accept.error.cancelled': 'Cette invitation a été annulée',
                'invitation.accept.error.email_mismatch': 'L\'email de votre compte ne correspond pas à l\'email de l\'invitation',
                'invitation.accept.success': 'Invitation acceptée. Redirection vers le chat...',
                'invitations.sent.title': 'Invitations envoyées',
                'invitations.sent.empty': 'Aucune invitation en attente',
                'invitations.pending.title': 'Invitations en attente',
                'invitations.columns.email': 'E-mail',
                'invitations.columns.language': 'Langue',
                "invitations.columns.mode": "Mode",
                'invitations.columns.status': 'Statut',
                'invitations.columns.sentAt': 'Envoyée',
                "invitations.columns.actions": "Actes",
                'invitations.status.pending': 'En attente',
                'invitations.status.accepted': 'Acceptée',
                'invitations.status.cancelled': 'Annulée',
                'invitations.status.expired': 'Expirée',
                'invitations.actions.cancel': 'Annuler',
                'invitations.actions.copy': 'Copier le lien',
                'invitations.actions.resend': 'Renvoyer l\'email',
                'profile.privacy.title': 'Confidentialité',
                'profile.privacy.public_visibility': 'Rendre mon profil publiquement visible',
                'profile.privacy.public_warning': 'Cela permet à tout utilisateur d\'ArChat® de vous trouver et de démarrer une conversation.',
                'profile.privacy.private_info': 'Votre profil est privé. Seuls les utilisateurs que vous invitez ou qui vous invitent pourront discuter avec vous.',
                'profile.privacy.private_default': 'Par défaut, votre profil est privé pour plus de sécurité.',
                'common.close': 'Fermer',
                'common.sending': 'Envoi...',
                'common.cancel': 'Annuler',
                'common.confirm': 'Confirmer',
                'common.save': 'Enregistrer',
                'common.saving': 'Enregistrement...',
                'buttons.accept': 'Accepter',
                'buttons.cancel': 'Annuler',
                'buttons.save': 'Enregistrer',
                'buttons.edit': 'Modifier',
                'buttons.retry': 'Réessayer',
                'buttons.confirm': 'Confirmer',
                'buttons.yes': 'Oui',
                'buttons.no': 'Non',
                'buttons.send': 'Envoyer',
                'buttons.close': 'Fermer',
                'buttons.continue': 'Continuer',
                'buttons.delete': 'Supprimer',
                'buttons.logout': 'Déconnexion',
                'buttons.back': 'Retour',
                'buttons.update': 'Mettre à jour',
                'buttons.upload': 'Télécharger',
                'buttons.select': 'Sélectionner',
                'conversation.backToContacts': 'Retour aux contacts',
                'help.title': 'Aide ArChat®',
                'help.what.title': 'Qu\'est-ce qu\'ArChat®?',
                'help.what.description': 'ArChat® est un système de messagerie écrite avec traduction automatique qui vous permet de communiquer avec des personnes qui ne parlent pas votre langue, en maintenant clarté, contexte et confidentialité dès le premier message.',
                'help.how.title': 'Comment ça marche?',
                'help.how.step1.title': 'Se connecter',
                'help.how.step1.description': 'Utilisez votre nick et mot de passe pour accéder au système. Si vous n\'avez pas de compte, il sera créé automatiquement.',
                'help.how.step2.title': 'Invitez votre contact',
                'help.how.step2.description': 'Invitez votre contact par email depuis votre profil. Définissez la langue et le mode de conversation dès le début.',
                'help.how.step3.title': 'Écrivez dans votre langue',
                'help.how.step3.description': 'Écrivez votre message dans votre langue préférée. Le système traduira automatiquement le message écrit.',
                'help.how.step4.title': 'L\'autre reçoit traduit',
                'help.how.step4.description': 'Le destinataire reçoit le message automatiquement traduit dans sa langue, en maintenant clarté et contexte.',
                'help.features.title': 'Fonctionnalités principales',
                'help.features.translation': '🌐 Traduction automatique et instantanée entre les langues',
                'help.features.status': '💬 Statut de présence (En ligne, Inactif, Ne pas déranger, etc.)',
                'help.features.statusCustom': '💬 Statuts personnalisés avec emoji et message personnalisé',
                'help.features.contacts': '👥 Liste complète de contacts avec recherche et filtres',
                'help.features.contactsMobile': '📱 Vue mobile optimisée avec informations complètes (nom, pays, statut)',
                'help.features.contactsFilter': '👁️ Bouton pour afficher/masquer les contacts non favoris - réduit la liste à vos favoris uniquement',
                'help.features.contactAlias': '✏️ Alias personnalisé et notes privées pour chaque contact - cliquez sur le nom du contact dans la conversation',
                'help.features.themes': '🎨 Deux thèmes disponibles: Argentine (bleu clair/blanc/doré) et Sombre (violet profond)',
                'help.features.messages': '📨 Messagerie en temps réel avec indicateurs de lecture',
                'help.features.attachments': '📎 Joindre des fichiers compatibles avec la communication écrite: images, vidéos et documents PDF',
                'help.features.camera': '📸 Capture de photos avec caméra avant, arrière ou webcam',
                'help.features.gallery': '🖼️ Sélection de fichiers depuis la galerie',
                'help.features.compression': '🗜️ Compression automatique des images et génération de miniatures',
                'help.features.progress': '📊 Barre de progression pendant le téléchargement de fichiers',
                'help.features.delete': '🗑️ Suppression de vos propres messages',
                'help.features.scroll': '⬇️ Défilement automatique vers le dernier message à l\'ouverture de la conversation',
                'help.features.profile': '👤 Profil personnalisable avec avatar, biographie et préférences',
                'help.features.profileEdit': '✏️ Édition de profil sans interruptions (pas de rafraîchissement pendant l\'édition)',
                'help.features.countries': '🌍 Liste complète de 195+ pays avec sélection automatique du fuseau horaire',
                'help.features.registration': '📧 Inscription avec confirmation par email et CAPTCHA de sécurité',
                'help.features.multilanguage': '🗣️ Support pour plusieurs langues (Espagnol, Anglais, Portugais, Français, Allemand, Italien, Russe, Chinois, Japonais, Coréen, Arabe, Hindi)',
                'help.features.pwa': '📲 Application PWA installable sur appareils mobiles et bureau',
                'help.features.sync': '🔄 Synchronisation automatique des messages toutes les 5 secondes',
                'help.features.deleteSync': '🗑️ Synchronisation automatique des messages supprimés entre appareils',
                'help.features.notifications': '🔔 Notifications sonores pour les nouveaux messages reçus',
                'help.features.retranslation': '🔄 Re-traduction automatique des messages si la première tentative échoue',
                'help.features.preview': '👁️ Aperçu des fichiers avant l\'envoi',
                'help.features.security': '🔒 Système de sécurité avec CAPTCHA, empreinte du navigateur et limitation de débit',
                'help.features.passwordRecovery': '🔑 Récupération de mot de passe par email',
                'help.features.emailConfirmation': '📧 Confirmation de compte par email avec lien d\'activation',
                'help.features.invitations': '📧 Invitations privées par email - Invitez des contacts externes avec langue et contexte définis',
                'help.features.invitationsManagement': '📋 Gestion complète des invitations - Liste, renvoyez ou annulez les invitations en attente depuis le menu',
                'help.features.contactStatus': '🏷️ Statut de contact visible - Voyez le statut de chaque contact (en attente, enregistré, prêt à discuter)',
                'help.features.favorites': '⭐ Système de favoris - Marquez les contacts comme favoris pour un accès rapide',
                'help.features.profilePhoto': '📸 Téléchargement amélioré de photo de profil - Sélectionnez des images depuis la galerie avec aperçu immédiat',
                'help.features.translationSender': '👁️ Visualisation des traductions pour l\'expéditeur - Voyez comment votre message a été traduit dans la langue du destinataire',
                'help.features.unifiedContacts': '🔗 Modèle de contacts unifié - Les contacts sont dérivés des invitations et conversations existantes',
                'help.features.privacy': '🔒 Mode privé par défaut - Votre profil est privé et accessible uniquement par invitation directe',
                'help.features.export': '💾 Exportation de conversations - Exportez des conversations complètes en PDF ou HTML avec images et fichiers',
                'help.tips.title': 'Conseils utiles',
                'help.tips.language': '✅ Configurez votre langue préférée dans votre profil pour recevoir des messages correctement traduits',
                'help.tips.status': '✅ Mettez à jour votre statut de présence pour que les autres connaissent votre disponibilité',
                'help.tips.statusCustom': '✅ Créez des statuts personnalisés avec emoji et message pour exprimer votre état actuel',
                'help.tips.search': '✅ Marquez des favoris (étoile) et bloquez des utilisateurs depuis le modal "Utilisateurs"',
                'help.tips.contactsFilter': '✅ Utilisez le bouton de l\'œil (👁️) dans la barre supérieure pour afficher ou masquer les contacts qui ne sont pas favoris',
                'help.tips.contactAlias': '✅ Cliquez sur le nom du contact dans la conversation pour ajouter un alias personnalisé et des notes privées',
                'help.tips.avatar': '✅ Cliquez sur l\'avatar d\'un contact pour voir son image en grand',
                'help.tips.messages': '✅ L\'icône ArChat® clignote lorsque vous avez des messages non lus',
                'help.tips.attachments': '✅ Joignez des images, vidéos ou PDFs en utilisant le bouton trombone (📎); compatible avec la communication écrite',
                'help.tips.camera': '✅ Utilisez la caméra pour capturer des photos directement depuis l\'app',
                'help.tips.compression': '✅ Les images sont automatiquement compressées pour économiser de l\'espace',
                'help.tips.delete': '✅ Vous pouvez supprimer vos propres messages en cliquant sur le bouton supprimer',
                'help.tips.profile': '✅ Modifiez votre profil sans souci: le système ne se rafraîchit pas pendant que vous modifiez',
                'help.tips.themes': '✅ Changez le thème depuis Paramètres > Apparence: Argentine (bleu clair) ou Sombre (violet profond)',
                'help.tips.country': '✅ Sélectionnez votre pays dans le profil pour que le fuseau horaire soit configuré automatiquement',
                'help.tips.registration': '✅ Lors de l\'inscription, vérifiez votre email pour activer complètement votre compte',
                'help.tips.writing': '✅ Écrivez des messages clairs: ArChat® traduit le sens du texte écrit, en maintenant contexte et clarté',
                'help.tips.install': '✅ Installez ArChat® comme application PWA sur votre appareil pour un accès rapide depuis le bureau',
                'help.tips.sync': '✅ Les messages sont synchronisés automatiquement toutes les 5 secondes - vous n\'avez pas besoin de rafraîchir',
                'help.tips.deleteSync': '✅ Si vous supprimez un message, il sera automatiquement supprimé sur tous les appareils du destinataire',
                'help.tips.notifications': '✅ Vous entendrez un son lorsque vous recevrez un nouveau message d\'un autre utilisateur',
                'help.tips.retranslation': '✅ Si un message n\'a pas été traduit correctement, le système tentera de le re-traduire automatiquement',
                'help.tips.preview': '✅ Examinez l\'aperçu du fichier avant de l\'envoyer pour vous assurer qu\'il s\'agit du bon',
                'help.tips.passwordRecovery': '✅ Si vous avez oublié votre mot de passe, utilisez le lien "Mot de passe oublié?" sur la connexion',
                'help.tips.emailConfirmation': '✅ Vérifiez votre email après l\'inscription et cliquez sur le lien de confirmation',
                'help.tips.languageChange': '✅ Changez votre langue à tout moment depuis le sélecteur de drapeaux - mise à jour instantanée',
                'help.tips.inputFixed': '✅ Sur PC, la barre d\'écriture reste fixe en bas de l\'écran pour plus de confort',
                'help.tips.invitations': '✅ Invitez des contacts par email depuis votre profil - Définissez la langue et le mode de conversation dès le début',
                'help.tips.invitationsManagement': '✅ Gérez vos invitations depuis le menu "Invitations envoyées" - Renvoyez des emails ou annulez les invitations en attente',
                'help.tips.contactStatus': '✅ Observez le statut de chaque contact dans la liste - En attente (orange), Enregistré (vert) ou Conversation active (bleu)',
                'help.tips.favorites': '✅ Marquez les contacts comme favoris avec l\'étoile ⭐ - Les favoris apparaissent en premier dans votre liste',
                'help.tips.profilePhoto': '✅ Téléchargez votre photo de profil depuis "Choisir dans la galerie" - Vous verrez un aperçu avant de sauvegarder',
                'help.tips.translationSender': '✅ Lors de l\'envoi d\'un message, développez le panneau de traduction pour voir comment il a été traduit dans la langue du destinataire',
                'help.tips.unifiedContacts': '✅ Vos contacts sont automatiquement affichés lorsqu\'ils acceptent des invitations ou que vous avez des conversations avec eux',
                'help.tips.privacy': '✅ Votre profil est privé par défaut - Activez la visibilité publique dans Profil > Confidentialité si vous voulez que d\'autres vous trouvent',
                'help.tips.export': '✅ Exportez des conversations complètes en utilisant le bouton ⬇️ dans l\'en-tête - Choisissez PDF ou HTML avec toutes les images',
                "help.support.title": "Moyen",
                'help.support.description': 'Si vous avez des problèmes ou des questions, contactez l\'administrateur du système ou consultez la documentation technique disponible.',
                'help.about.title': 'À propos',
                'help.about.developer': 'Développé par:',
                'help.about.location': 'MDQ - ARGENTINE',
                'help.about.linkedin': 'Voir le profil LinkedIn',
                'presence.title': 'Statut de présence',
                'presence.currentStatus': 'Statut actuel:',
                'presence.changeStatus': 'Changer le statut',
                'presence.status.online': 'En ligne',
                'presence.status.online.title': 'En ligne - Visible pour tous',
                'presence.status.online.description': 'En ligne: Visible pour tous les contacts',
                'presence.status.idle': 'Inactif',
                'presence.status.idle.title': 'Inactif - Indique une absence temporaire',
                'presence.status.idle.description': 'Inactif: Indique que vous êtes temporairement indisponible',
                'presence.status.dnd': 'Ne pas déranger',
                'presence.status.dnd.title': 'Ne pas déranger - Indique que vous préférez ne pas être interrompu',
                'presence.status.dnd.description': 'Ne pas déranger: Signal visible que vous préférez ne pas être interrompu',
                'presence.status.busy': 'Occupé',
                'presence.status.busy.title': 'Occupé - Non disponible',
                'presence.status.busy.description': 'Occupé: Non disponible',
                'presence.status.offline': 'Hors ligne',
                'presence.status.offline.title': 'Déconnecté - Apparaître hors ligne',
                'presence.status.offline.description': 'Hors ligne: Apparaître déconnecté',
                'presence.status.custom': 'Personnalisé',
                'presence.status.custom.title': 'Personnalisé - Statut unique avec emoji',
                'presence.status.custom.description': 'Personnalisé: Statut unique avec emoji et expiration optionnelle',
                "dashboard.title": "Tableau de bord",
                'dashboard.planUsage': 'Utilisation du plan',
                'dashboard.filesSummary': 'Mes fichiers',
                "dashboard.promotions": "Promotions",
                'dashboard.sessions': 'Sessions actives',
                'dashboard.explore': 'Explorer',
                'dashboard.noSessions': 'Aucune session active',
                'dashboard.welcomeTitle': 'Bienvenue sur ArChat®',
                'dashboard.welcomeSubtitle': 'Communiquez dans n’importe quelle langue.',
                'dashboard.stepInvite': 'Étape 1 : invitez votre premier contact',
                'dashboard.stepMessage': 'Étape 2 : envoyez votre premier message',
                'dashboard.inviteContact': 'Inviter un contact',
                'dashboard.exploreArChat': 'Découvrir ArChat',
                "dashboard.promotionsTitle": "Promotions",
                'dashboard.promotionsText': 'Aperçu du programme de parrainage et de récompenses.',
                'dashboard.viewPromotions': 'Voir les promotions',
                'dashboard.usageTitle': 'Utilisation du forfait',
                'dashboard.sessionsTitle': 'Sessions actives',
                'dashboard.sessionsEmpty': 'Aucune session active',
                'dashboard.filesTitle': 'Mes fichiers',
                'dashboard.viewFiles': 'Voir mes fichiers',
                'dashboard.noBlocks': 'Aucun bloc actif. Activez-en au moins un dans Paramètres.',
                'dashboard.openSettings': 'Ouvrir les paramètres',
                'dashboard.goToContacts': 'Aller aux contacts',
                'dashboard.filesVisible': 'Fichiers visibles',
                'dashboard.filesSampleNote': 'Décompte sur la première page (jusqu’à 500+).',
                'dashboard.loading': 'Chargement des données...',
                'dashboard.error.title': 'Erreur',
                'dashboard.error.load': 'Impossible de charger les données d\'utilisation',
                'dashboard.error.generic': 'Erreur lors du chargement du tableau de bord',
                'dashboard.error.no_data': 'Impossible de charger les données',
                'dashboard.retry': 'Réessayer',
                'dashboard.unlimited': 'Illimité',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                "dashboard.card.contacts": "Contacts",
                'dashboard.card.chars': 'Caractères',
                'dashboard.card.chars_month': 'Caractères ce mois',
                'dashboard.card.storage': 'Stockage',
                'dashboard.card.devices': 'Appareils actifs',
                'dashboard.upgrade.title': 'Besoin de plus de ressources?',
                'dashboard.upgrade.message': 'Améliorez votre plan pour plus de contacts, caractères, stockage et appareils actifs.',
                'dashboard.upgrade.button': 'Améliorer le plan',
                'upgrade.title': 'Améliorer le plan',
                'upgrade.close': 'Fermer',
                'upgrade.cancel': 'Annuler',
                'upgrade.activate': 'Activer le plan PRO',
                'upgrade.activating': 'Activation...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'Comparaison des plans',
                'upgrade.free.label': 'Plan gratuit',
                "upgrade.free.limits.contacts": "2 contacts maximum",
                "upgrade.free.limits.conversations": "2 conversations maximum",
                'upgrade.free.limits.no_export': 'Pas d\'exportation de données',
                'upgrade.free.limits.no_advanced': 'Pas de fonctionnalités avancées',
                "upgrade.pro.label": "Forfait Pro",
                'upgrade.pro.recommended': 'RECOMMANDÉ',
                'upgrade.pro.benefits.contacts': 'Contacts illimités',
                'upgrade.pro.benefits.contacts.desc': 'Ajoutez tous les contacts dont vous avez besoin sans restrictions',
                'upgrade.pro.benefits.conversations': 'Conversations illimitées',
                'upgrade.pro.benefits.conversations.desc': 'Gardez toutes les conversations actives dont vous avez besoin',
                'upgrade.pro.benefits.export': 'Exportation de conversations',
                'upgrade.pro.benefits.export.desc': 'Exportez vos conversations en plusieurs formats (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Notifications avancées',
                'upgrade.pro.benefits.notifications.desc': 'Notifications personnalisées et configuration avancée',
                'upgrade.pro.benefits.translation': 'Traduction automatique illimitée',
                'upgrade.pro.benefits.translation.desc': 'Traduisez les messages sans limites d\'utilisation',
                'upgrade.pro.benefits.files': 'Envoi de fichiers illimité',
                'upgrade.pro.benefits.files.desc': 'Partagez des fichiers de toute taille sans restrictions',
                'upgrade.pro.benefits.themes': 'Thèmes personnalisés',
                'upgrade.pro.benefits.themes.desc': 'Accès à tous les thèmes et personnalisation avancée',
                'upgrade.pro.benefits.security': 'Sécurité avancée',
                'upgrade.pro.benefits.security.desc': 'Protection supplémentaire et fonctionnalités de confidentialité améliorées',
                'upgrade.pro.benefits.analytics': 'Statistiques et analyses',
                'upgrade.pro.benefits.analytics.desc': 'Accédez à des statistiques détaillées de votre activité',
                'upgrade.pro.benefits.priority': 'Support prioritaire',
                'upgrade.pro.benefits.priority.desc': 'Attention prioritaire et réponse rapide à vos questions',
                "upgrade.enterprise.label": "Forfait Entreprise",
                'upgrade.enterprise.benefits.contacts': 'Contacts illimités',
                'upgrade.enterprise.benefits.support': 'Support prioritaire 24/7',
                'upgrade.enterprise.benefits.custom': 'Solutions personnalisées',
                'upgrade.enterprise.benefits.advanced': 'Fonctionnalités d\'entreprise avancées',
                'upgrade.enterprise.benefits.integration': 'Intégrations personnalisées',
                'upgrade.enterprise.benefits.dedicated': 'Support dédié',
                'upgrade.success.title': 'Plan PRO activé',
                'upgrade.success.message': 'Votre plan a été mis à jour vers PRO. Profitez de toutes les fonctionnalités illimitées.',
                'upgrade.error.title': 'Erreur lors de l\'activation de PRO',
                'upgrade.error.message': 'Impossible de mettre à jour le plan. Veuillez réessayer.',
                'upgrade.error.generic': 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
                'upgrade.benefits.contacts': 'Contacts illimités',
                'upgrade.benefits.contacts.desc': 'Ajoutez tous les contacts dont vous avez besoin sans restrictions',
                'upgrade.benefits.conversations': 'Conversations illimitées',
                'upgrade.benefits.conversations.desc': 'Gardez toutes les conversations actives dont vous avez besoin',
                'upgrade.benefits.export': 'Exportation de conversations',
                'upgrade.benefits.export.desc': 'Exportez vos conversations en plusieurs formats (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Notifications avancées',
                'upgrade.benefits.notifications.desc': 'Notifications personnalisées et configuration avancée',
                'upgrade.benefits.translation': 'Traduction automatique illimitée',
                'upgrade.benefits.translation.desc': 'Traduisez les messages sans limites d\'utilisation',
                'upgrade.benefits.files': 'Envoi de fichiers illimité',
                'upgrade.benefits.files.desc': 'Partagez des fichiers de toute taille sans restrictions',
                'upgrade.benefits.themes': 'Thèmes personnalisés',
                'upgrade.benefits.themes.desc': 'Accès à tous les thèmes et personnalisation avancée',
                'upgrade.benefits.security': 'Sécurité avancée',
                'upgrade.benefits.security.desc': 'Protection supplémentaire et fonctionnalités de confidentialité améliorées',
                'upgrade.benefits.analytics': 'Statistiques et analyses',
                'upgrade.benefits.analytics.desc': 'Accédez à des statistiques détaillées de votre activité',
                'upgrade.benefits.priority': 'Support prioritaire',
                'upgrade.benefits.priority.desc': 'Attention prioritaire et réponse rapide à vos questions',
                "upgrade.limits.contacts": "2 contacts maximum",
                "upgrade.limits.conversations": "2 conversations maximum",
                'upgrade.limits.no_export': 'Pas d\'exportation de données',
                'upgrade.limits.no_advanced': 'Pas de fonctionnalités avancées',
                // API Error Messages
                'api.error.image_processing_not_available': 'Le traitement d\'images n\'est pas disponible sur le serveur',
                'api.error.image_functions_not_available': 'Fonctions de traitement d\'images non disponibles',
                'api.error.method_not_allowed': 'Méthode non autorisée',
                'api.error.user_not_identified': 'Utilisateur non identifié',
                'api.error.upload_file_too_large_php': 'Le fichier dépasse la taille maximale autorisée par PHP',
                'api.error.upload_file_too_large_form': 'Le fichier dépasse la taille maximale autorisée par le formulaire',
                'api.error.upload_file_partial': 'Le fichier a été partiellement téléchargé',
                'api.error.upload_no_file': 'Aucun fichier n\'a été téléchargé',
                'api.error.upload_no_temp_dir': 'Répertoire temporaire manquant',
                'api.error.upload_cant_write': 'Erreur lors de l\'écriture du fichier sur le disque',
                'api.error.upload_extension_stopped': 'Une extension PHP a arrêté le téléchargement',
                'api.error.upload_generic': 'Erreur de téléchargement de fichier',
                'api.error.file_type_not_allowed': 'Type de fichier non autorisé. Seules les images sont autorisées (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'Le fichier est trop volumineux (max 10MB)',
                'api.error.storage_limit_exceeded': 'Limite de stockage dépassée. Améliorez votre plan pour télécharger plus de fichiers.',
                'api.error.user_not_found': 'Utilisateur introuvable ou inactif',
                'api.error.image_directory_access': 'Erreur d\'accès au répertoire d\'images',
                'api.error.file_extension_not_allowed': 'Extension de fichier non autorisée',
                'api.error.temp_file_save': 'Erreur lors de l\'enregistrement du fichier temporaire',
                'api.error.image_processing': 'Erreur lors du traitement de l\'image',
                'api.error.database_update': 'Erreur lors de la mise à jour de la base de données',
                'api.error.internal_server_error': 'Erreur interne du serveur',
                'api.error.internal_server_error_debug': 'Erreur interne du serveur',
                'api.error.user_id_required': 'ID utilisateur requis',
                'api.error.profile_not_found': 'Profil introuvable',
                'api.error.profile_load_failed': 'Erreur lors du chargement du profil',
                'api.error.invalid_data': 'Données invalides',
                'api.error.validation_errors': 'Erreurs de validation',
                'api.error.profile_update_failed': 'Impossible de mettre à jour le profil',
                'api.error.profile_update_error': 'Erreur lors de la mise à jour du profil',
                // API Success Messages
                'api.success.photo_updated': 'Photo mise à jour',
                'api.success.profile_loaded': 'Profil chargé avec succès',
                'api.success.profile_updated': 'Profil mis à jour avec succès',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Limite d\'appareils atteinte',
                'errors.deviceLimit.solution': 'Pour continuer, déconnectez-vous des autres appareils ou améliorez votre forfait.',
                // Error Messages - Network
                'errors.network.title': 'Erreur de connexion',
                'errors.network.message': 'Impossible de se connecter au serveur. Vérifiez votre connexion Internet.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Erreur du serveur',
                'errors.server.invalidResponse.message': 'Le serveur a renvoyé une réponse invalide. Veuillez réessayer.',
                // Error Messages - Generic
                'errors.generic.title': 'Erreur',
                'errors.generic.message': 'Une erreur s\'est produite. Veuillez réessayer.',
                'errors.generic.403.title': 'Erreur d\'accès',
                'errors.generic.403.message': 'Vous n\'avez pas la permission d\'effectuer cette action.',
                'errors.saas_max_users': 'Limite d\'utilisateurs du plan atteinte ({current}/{limit}).',
                'errors.tenant_frozen': 'Le tenant est temporairement bloqué.',
                'errors.auth_invalid_credentials': 'Identifiant ou mot de passe incorrect.',
                'errors.unexpected_error': 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
                'errors.accountInactive.title': 'Le compte est inactif. Entrez votre e-mail pour le réactiver.',
                'errors.accountInactive.activate': 'Activer maintenant',
                'errors.accountInactive.accept': 'Accepter',
                'errors.accountInactive.success': 'Compte réactivé. Vous pouvez vous connecter.',
                'errors.accountInactive.fail': 'Impossible de réactiver le compte. Veuillez réessayer.',
                'errors.accountInactive.completeSuccess': 'Compte activé avec votre e-mail. Vous pouvez vous connecter.',
                'errors.accountInactive.completeFail': 'Impossible de finaliser l\'activation. Vérifiez l\'e-mail et réessayez.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Limite du forfait atteinte',
                'plan.errors.deviceLimit.message': 'Votre forfait actuel a une limite sur le nombre d\'appareils pouvant être connectés simultanément.',
                'plan.errors.deviceLimit.solution': 'Pour continuer, déconnectez-vous des autres appareils ou améliorez votre forfait vers PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Limite de contacts atteinte',
                'plan.errors.contactsLimit.message': 'Votre forfait actuel a une limite sur le nombre de contacts que vous pouvez avoir.',
                'plan.errors.contactsLimit.solution': 'Pour ajouter plus de contacts, améliorez votre forfait vers PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Limite d\'invitations atteinte',
                'plan.errors.invitationsLimit.message': 'Votre forfait actuel a une limite sur le nombre d\'invitations que vous pouvez envoyer par jour.',
                'plan.errors.invitationsLimit.solution': 'Pour envoyer plus d\'invitations, améliorez votre forfait vers PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Limite de messages atteinte',
                'plan.errors.messagesLimit.message': 'Votre forfait actuel a une limite sur le nombre de messages que vous pouvez envoyer par jour.',
                'plan.errors.messagesLimit.solution': 'Pour envoyer plus de messages, améliorez votre forfait vers PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Limite de stockage atteinte',
                'plan.errors.storageLimit.message': 'Votre forfait actuel a une limite sur la quantité de stockage disponible.',
                'plan.errors.storageLimit.solution': 'Pour obtenir plus de stockage, améliorez votre forfait vers PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Amélioration du forfait requise',
                'plan.errors.upgradeRequired.message': 'Cette fonctionnalité nécessite un forfait supérieur à votre forfait actuel.',
                'plan.errors.upgradeRequired.solution': 'Améliorez votre forfait vers PRO pour accéder à cette fonctionnalité.',
                'appearance.theme.system': 'Système',
                "appearance.theme.corporate": "Entreprise",
                'theme.system': 'Système',
                "theme.corporate": "Entreprise",
                "founder.title": "FONDATION (Fondateur)",
                'founder.subtitle': 'Vous soutenez le projet dès le départ avec un prix à vie.',
                'founder.whatIs': 'Les 150 premiers utilisateurs obtiennent le plan FOUNDATION à prix réduit à vie.',
                'founder.howItWorks': 'Votre niveau Founder dépend de votre position (1 à 150).',
                'founder.benefitsTitle': 'Avantages',
                'founder.benefitPrice': '$15 / mois (tarif Founder)',
                'founder.benefitFeatures': 'Inclut toutes les fonctionnalités du plan PRO.',
                'founder.limit': 'Il n\'existe que 150 places Founder.',
                'founder.cancelRule': 'Si vous annulez, vous perdez le statut Founder tant que vous êtes désabonné.',
                'founder.rejoinRule': 'Si une place se libère, vous pouvez réactiver et redevenir Founder automatiquement.',
                'founder.tiers.title': 'Niveaux Founder',
                "founder.tiers.legendary.name": "Fondateur LÉGENDAIRE",
                "founder.tiers.legendary.range": "Positions 1 à 25",
                'founder.tiers.legendary.desc': 'Les premiers à soutenir le projet. Priorité historique maximale.',
                "founder.tiers.early.name": "PREMIER Fondateur",
                "founder.tiers.early.range": "Postes 26 à 75",
                'founder.tiers.early.desc': 'Soutien précoce avec reconnaissance spéciale.',
                "founder.tiers.founder.name": "fondateur",
                "founder.tiers.founder.range": "Position 76-150",
                'founder.tiers.founder.desc': 'Place Founder parmi les 150.',
                'founder.whatIsLink': 'Qu\'est-ce que Founder ?',
                'founder.viewTiers': 'Voir les niveaux Founder',
                'founder.modalClose': 'Fermer',
                'founder.activeCountLabel': 'Founders actifs',
                'founder.urgency.lastSlots': 'Dernières places Founder disponibles',
                "founder.positionLabel": "Fondateur #{position} / {limit}",
                "founder.leaderboard.title": "Principaux fondateurs",
                'login.email.placeholder': 'Saisissez votre e-mail pour confirmer votre compte',
                'login.email.help': 'Un lien de confirmation sera envoyé à votre e-mail',
                'auth.user_not_found': 'Utilisateur introuvable.',
                'auth.user_inactive': 'Votre compte est désactivé. Contactez l\'administrateur.',
                'auth.tenant_mismatch': 'Votre compte n\'appartient pas à cet environnement. Contactez l\'administrateur.',
                'auth.captcha_required': 'Vous devez compléter la vérification de sécurité (CAPTCHA).',
                'mail.send_failed': 'Impossible d\'envoyer l\'e-mail de récupération. Vérifiez la configuration SMTP ou réessayez plus tard.',
                'auth.resend_activation': 'Renvoyer l\'e-mail d\'activation',
                'register.creatingAccount': 'Création de votre compte…',
                'common.edit': 'Modifier',
                'common.on': 'Activé',
                'common.off': 'Désactivé',
                'common.refresh': 'Actualiser',
                'system.processing': 'Traitement en cours...',
                'captcha.incorrect': 'La réponse CAPTCHA est incorrecte.',
                'captcha.placeholder': 'Saisissez la réponse',
                'captcha.questionFormat': 'Combien font {a} + {b} ?',
                "menu.admin": "Administration",
                "navbar.open_guide": "Guide",
                'help.how_archat_works': 'Comment fonctionne ArChat®',
                'help.registration': 'Inscription',
                'help.private_invitations': 'Invitations privées',
                'help.messaging': 'Messagerie',
                'help.security': 'Sécurité',
                'invitation.quick_button': 'Inviter un contact',
                'onboarding.title': 'Bienvenue sur ArChat®',
                'onboarding.subtitle': 'Communiquez avec n\'importe qui, dans n\'importe quelle langue.',
                'onboarding.step1.label': 'Étape 1',
                'onboarding.step1.text': 'Invitez votre premier contact',
                'onboarding.step2.label': 'Étape 2',
                'onboarding.step2.text': 'Envoyez votre premier message',
                'onboarding.actions.invite': 'Inviter un contact',
                'onboarding.actions.explore': 'Découvrir ArChat®',
                'suggestions.sendSuccess': 'Votre suggestion a été envoyée avec succès.',
                'suggestions.sendError': 'Impossible d\'envoyer la suggestion. Veuillez réessayer.',
                'suggestions.sent': 'La suggestion a été envoyée avec succès.',
                'errors.suggestionSend': 'Impossible d\'envoyer la suggestion. Veuillez réessayer.',
                'app.install': 'Installer ArChat',
                "menu.open": "Menu",
                'contacts.controls.hide_non_favorites': 'Masquer les contacts non favoris',
                'contacts.controls.show_all': 'Afficher tous les contacts',
                "common.navigation": "Navigation",
                'common.favorite': 'Favori',
                'common.block': 'Bloquer',
                'common.user': 'Utilisateur',
                'message.new': 'Nouveau message',
                'message.edit': 'Modifier le message',
                'message.edit.save': 'Enregistrer la modification',
                'message.edit.cancel': 'Annuler la modification',
                'message.translating': 'Traduction en cours...',
                'message.translation_failed': 'Traduction impossible',
                'message.not_translated': 'Texte original',
                'message.retry_send': 'Réessayer',
                'message.retrying': 'Nouvelle tentative...',
                'message.delete': 'Supprimer le message',
                'message.deleted_placeholder': 'Message supprimé',
                'message.edited': 'Modifié',
                'message.edited_at': 'Modifié le',
                'message.delete_for_me.tooltip': 'Supprimer pour moi',
                'message.delete_for_me.aria': 'Supprimer ce message uniquement pour moi',
                'message.delete_for_me.confirm_title': 'Supprimer le message',
                'message.delete_for_me.confirm_message': 'Ce message sera supprimé uniquement de votre vue.',
                'message.delete_for_everyone.tooltip': 'Supprimer pour tous',
                'message.delete_for_everyone.aria': 'Supprimer ce message pour tous les participants',
                'message.delete_for_everyone.confirm_title': 'Supprimer le message pour tous',
                'message.delete_for_everyone.confirm_message': 'Ce message sera supprimé pour vous et l\'autre participant.',
                'message.delete_for_everyone.window_expired': 'Délai de suppression expiré',
                'message.translation.show': 'Voir l\'original et la traduction',
                'message.translation.hide': 'Masquer la traduction',
                'emoji.search': 'Rechercher un emoji',
                'emoji.close': 'Fermer le sélecteur',
                'captcha.refresh': 'Régénérer le CAPTCHA',
                'presence.unavailable': 'Statuts indisponibles',
                'presence.maintenance': 'Serveur en maintenance',
                'home.access_nav': 'Accès à l\'application',
                'common.requiredFields': 'Complétez tous les champs obligatoires.',
                'bio.view': 'Voir la biographie',
                "profile.invitations.title": "Invitations",
                'profile.invitations.validated': 'Invitations validées',
                'profile.invitations.nextBadge': 'Prochain badge',
                'profile.invitations.progress': 'Progression',
                'profile.invitations.achievement': 'Réussite',
                'profile.invitations.topInviterAchieved': 'Meilleur inviteur atteint',
                'profile.invitations.badges.networkBuilder': 'Bâtisseur de réseau',
                'profile.invitations.badges.topInviter': 'Meilleur inviteur',
                'profile.invitations.achievement.networkBuilderMessage': 'Vous avez invité 20 utilisateurs sur ArChat.',
                'profile.invitations.achievement.topInviterMessage': 'Vous avez invité 50 utilisateurs sur ArChat.',
                'profile.manage_plan': 'Gérer le plan',
                'plan.current_plan': 'Plan actuel',
                'plan.current': 'Actuel',
                'plan.footer_prefix': 'Plan :',
                'plan.upgrade_to_pro': 'Passer à PRO',
                'plan.upgrade_to_foundation': 'Passer à FOUNDATION',
                'plan.payment_coming': 'Le paiement récurrent sera bientôt disponible. Vous pourrez changer de plan depuis cet écran.',
                'plan.payment_coming_title': 'Bientôt disponible',
                'plan.foundation_full': 'Le quota FOUNDATION est complet (150 Founders). Vous pouvez choisir PRO.',
                'plan.sold_out': 'Épuisé',
                'plan.founder_spots_remaining': 'Il ne reste que {count} places disponibles',
                'plan.founders_occupied': 'Founders occupés',
                'plan.upgrade_not_allowed': 'Seuls les utilisateurs avec le plan FREE peuvent demander une mise à niveau.',
                'plan.free_contacts': 'Jusqu\'à 2 contacts',
                'plan.free_no_files': 'Sans fichiers',
                'plan.free_retention': 'Historique de 30 jours',
                'plan.pro_files': 'Fichiers jusqu\'à 50 Mo',
                'plan.pro_export': 'Exportation',
                'plan.founder_support': 'Support prioritaire',
                'plan.founder_badge': 'Badge Founder',
                "billing.usage.contacts": "Contacts",
                'billing.usage.chars_month': 'Caractères par mois',
                'billing.usage.storage': 'Stockage utilisé',
                'billing.usage.devices': 'Appareils connectés',
                'billing.loading': 'Chargement...',
                'billing.subscription.section_title': 'Abonnement et facturation',
                'billing.subscription.provider_note': 'Fournisseur',
                'billing.subscription.paddle_active': 'Paddle (plan actif dans l’app)',
                'billing.subscription.mp_action_ok': 'Demande enregistrée. Si le paiement ne s’est pas ouvert, vérifiez votre connexion ou réessayez.',
                'billing.paddle.manage_subscription_button': 'Gérer l’abonnement',
                'billing.paddle.portal_confirm_title': 'Portail de facturation',
                'billing.paddle.portal_confirm': 'Le portail sécurisé Paddle s’ouvrira pour mettre à jour le moyen de paiement, les factures ou annuler l’abonnement. Continuer ?',
                'billing.paddle.portal_opened_hint': 'Le portail Paddle s’est ouvert dans un nouvel onglet. Actualisez votre profil si le plan n’a pas été mis à jour.',
                'billing.paddle.portal_error': 'Impossible d’ouvrir le portail Paddle. Réessayez plus tard ou contactez le support.',
                'billing.paddle.no_link_error': 'Aucun lien d’abonnement Paddle sur votre compte pour l’instant. Si vous venez de payer, attendez le webhook ou contactez le support.',
                'billing.paddle.api_not_configured': 'Le serveur n’a pas la configuration API Paddle (PADDLE_API_KEY). Un administrateur doit la définir.',
                'billing.descriptions.contacts': 'Total des contacts enregistrés dans votre compte',
                'billing.descriptions.storage': 'Stockage utilisé pour les fichiers et médias',
                'billing.descriptions.chars_month': 'Caractères traduits ce mois-ci',
                'billing.descriptions.devices': 'Appareils actifs connectés',
                'billing.paddle.return_title': 'Paiement reçu',
                'billing.paddle.return_body': 'Si vous avez terminé le paiement, votre plan sera mis à jour peu après confirmation par Paddle. Vous pouvez retourner à l’accueil.',
                'billing.paddle.verifying': 'Vérification de votre plan…',
                'billing.paddle.not_logged_in': 'Connectez-vous pour voir l’état de votre plan.',
                'billing.paddle.plan_updated': 'Plan mis à jour : {plan}',
                'billing.paddle.plan_current': 'Votre plan actuel : {plan}',
                'billing.paddle.plan_current_founder': 'Vous êtes maintenant Founder — {plan}',
                'billing.paddle.still_free_hint': 'Si vous voyez encore FREE après un court délai, le webhook peut être retardé. Consultez les journaux du serveur ou actualisez cette page.',
                'billing.paddle.pro_extra_hint': 'Vous pouvez retourner à l’accueil pour utiliser votre plan.',
                'avatar.errors.too_large': 'L\'image est trop volumineuse. Taille maximale : 2 Mo.',
                'avatar.preview.title': 'Aperçu de l\'avatar',
                'profile.avatar.error_title': 'Impossible de mettre à jour l\'avatar',
                'profile.avatar.error.title': 'Impossible de mettre à jour l\'avatar',
                'profile.avatar.error.size': 'L\'image dépasse la taille autorisée. Maximum : 2 Mo.',
                'profile.avatar.tooLarge.title': 'Image trop volumineuse',
                'profile.avatar.tooLarge.message': 'La photo dépasse la taille autorisée. Maximum : 2 Mo.',
                'profile.avatar.uploadError.title': 'Impossible de mettre à jour l\'avatar',
                'profile.avatar.uploadError.message': 'Un problème est survenu lors de l\'envoi de l\'image. Veuillez réessayer.',
                'profile.saveSuccess.title': 'Profil mis à jour',
                'profile.saveSuccess.message': 'Vos modifications ont été enregistrées avec succès.',
                'profile.avatar.file_too_large': 'L\'image dépasse la taille maximale autorisée (2 Mo).',
                'profile.avatar.file_too_large_hint': 'Choisissez une image plus légère ou réduisez sa taille, puis réessayez.',
                'profile.photo.camera.front': 'Caméra frontale',
                'profile.photo.camera.back': 'Caméra arrière',
                'profile.photo.camera.web': 'Webcam',
                'profile.photo.close': 'Fermer',
                'block.toggle_error': 'Impossible de bloquer ou de débloquer.',
                'contact.favorite.add': 'Ajouter aux favoris',
                'contact.favorite.remove': 'Retirer des favoris',
                'contact.block.block': 'Bloquer',
                'contact.block.unblock': 'Débloquer',
                'conversation.notFound': 'Conversation introuvable',
                'help.howWorks.title': '👥 Comment fonctionne ArChat® (flux réel)',
                'help.howWorks.step1.title': '1️⃣ Inscription',
                'help.howWorks.step1.point1': 'Connectez-vous avec votre identifiant et votre mot de passe.',
                'help.howWorks.step1.point2': 'Si vous n\'avez pas de compte, il est créé automatiquement.',
                'help.howWorks.step1.point3': 'Vous acceptez les Conditions générales dans votre langue.',
                'help.howWorks.step1.point4': 'Vous confirmez votre compte par e-mail.',
                'help.howWorks.step2.title': '2️⃣ Invitations privées',
                'help.howWorks.step2.point1': 'Invitez des contacts par e-mail depuis votre profil.',
                'help.howWorks.step2.point2': 'Définissez la langue et le mode de conversation avant de commencer.',
                'help.howWorks.step2.point3': 'Le contact reçoit une invitation privée.',
                'help.howWorks.step2.point4': 'Vous pouvez voir son état : En attente, Inscrit, Prêt à converser',
                'help.howWorks.step2.point5': 'Les contacts ne se recherchent pas, ils s\'invitent.',
                'help.howWorks.step2.point6': 'Les contacts ne se recherchent pas, ils s\'invitent.',
                'help.howWorks.step3.title': '3️⃣ Contacts et conversations',
                'help.howWorks.step3.point1': 'Vos contacts apparaissent automatiquement lorsque :',
                'help.howWorks.step3.point2': 'ils acceptent une invitation',
                'help.howWorks.step3.point3': 'ou qu\'une conversation existe',
                'help.howWorks.step3.point4': 'Vous pouvez :',
                'help.howWorks.step3.point5': 'les marquer comme favoris ⭐',
                'help.howWorks.step3.point6': 'leur attribuer des alias personnalisés',
                'help.howWorks.step3.point7': 'ajouter des notes privées',
                'help.howWorks.step3.point8': 'les bloquer ou les gérer',
                'help.howWorks.step3.point9': 'Il n\'y a pas d\'annuaire public ni d\'utilisateurs visibles sans consentement.',
                'help.howWorks.step4.title': '4️⃣ Messagerie avec traduction',
                'help.howWorks.step4.point1': 'Écrivez toujours dans votre langue.',
                'help.howWorks.step4.point2': 'Le système traduit automatiquement le message.',
                'help.howWorks.step4.point3': 'Le destinataire le reçoit dans sa langue.',
                'help.howWorks.step4.point4': 'Vous pouvez voir la traduction appliquée.',
                'help.howWorks.step4.point5': 'Si une traduction échoue, le système réessaie automatiquement.',
                'help.howWorks.step4.point6': 'ArChat® privilégie la clarté et le sens, pas seulement la vitesse.',
                'help.privacy.title': '🔒 Confidentialité et contrôle',
                'help.privacy.point1': 'Votre profil est privé par défaut.',
                'help.privacy.point2': 'Seules les personnes que vous invitez peuvent vous voir ou vous écrire.',
                'help.privacy.point3': 'La visibilité publique est optionnelle et désactivée par défaut.',
                'help.privacy.point4': 'Sécurité active avec :',
                "help.privacy.point5": "CAPTCHA",
                "help.privacy.point6": "limitation de débit",
                "help.privacy.point7": "empreinte digitale",
                'help.privacy.point8': 'vérification par e-mail',
                'help.privacy.point9': 'Vos conversations ne sont ni publiques ni indexées.',
                'help.files.title': '📎 Fichiers et exportation',
                'help.files.point1': 'Joignez des images, vidéos et documents PDF.',
                'help.files.point2': 'Prenez des photos avec la caméra frontale, arrière ou la webcam.',
                'help.files.point3': 'Les images sont compressées automatiquement.',
                'help.files.point4': 'Aperçu avant l\'envoi.',
                'help.files.point5': 'Barre de progression pendant le chargement.',
                'help.files.point6': 'Exportez des conversations complètes vers :',
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                'help.files.point9': 'Inclut messages, images et fichiers.',
                'help.files.point10': 'Vos données vous appartiennent.',
                'help.experience.title': '🎨 Expérience utilisateur',
                'help.experience.point1': 'États de présence et statuts personnalisés avec emoji.',
                'help.experience.point2': 'Emojis OpenMoji intégrés.',
                'help.experience.point3': 'Indicateurs de lecture et de saisie.',
                'help.experience.point4': 'Vue mobile optimisée équivalente au bureau.',
                'help.experience.point5': 'Application PWA installable.',
                'help.experience.point6': 'Deux thèmes : Argentine (bleu ciel/blanc/doré) et Sombre (violet profond).',
                'help.experience.point7': 'Édition du profil sans rechargement.',
                'help.experience.point8': 'Sélecteur de pays avec fuseau horaire automatique.',
                'help.experience.point9': 'Accès rapide avec favoris, recherche et filtres.',
                'help.languages.title': '🌍 Langues',
                'help.languages.point1': 'Prise en charge de {count} langues.',
                'help.languages.point2': 'Sélecteur visuel avec drapeaux.',
                'help.languages.point3': 'Interface, CGU et e-mails adaptés à la langue choisie.',
                'help.languages.point4': 'Traduction automatique bidirectionnelle entre utilisateurs.',
                'help.tipsNew.title': '💡 Conseils pour profiter d\'ArChat®',
                'help.tipsNew.point1': 'Invitez uniquement les personnes avec lesquelles vous souhaitez vraiment communiquer.',
                'help.tipsNew.point2': 'Utilisez des alias et des notes privées pour organiser vos contacts.',
                'help.tipsNew.point3': 'Marquez des favoris pour un accès rapide.',
                'help.tipsNew.point4': 'Vérifiez la traduction avant d\'envoyer des messages importants.',
                'help.tipsNew.point5': 'Exportez les conversations importantes pour sauvegarde ou travail.',
                'help.tipsNew.point6': 'Utilisez ArChat® lorsque la clarté écrite est essentielle.',
                'help.whySubscribe.title': '🚀 Pourquoi s\'abonner à ArChat®',
                'help.whySubscribe.point1': 'ArChat® n\'est pas conçu pour discuter avec n\'importe qui,',
                'help.whySubscribe.point2': 'mais pour mieux communiquer avec ceux qui comptent.',
                'help.whySubscribe.point3': 'Si vous avez besoin de :',
                'help.whySubscribe.point4': 'clarté entre les langues',
                'help.whySubscribe.point5': 'véritable confidentialité',
                'help.whySubscribe.point6': 'contrôle des contacts',
                'help.whySubscribe.point7': 'exportation des conversations',
                'help.whySubscribe.point8': 'une expérience professionnelle et sans bruit',
                'help.whySubscribe.point9': 'ArChat® est conçu pour cela.',
                'help.message_time_context.title': 'Contexte temporel des messages',
                'help.message_time_context.description': 'Chaque message peut enregistrer l\'heure locale de l\'expéditeur, son fuseau horaire et son pays au moment de l\'envoi. Vous pouvez ainsi voir d\'où et à quelle heure l\'autre utilisateur a envoyé le message.',
                'help.message_time_context.point1': 'Avec le plan FREE, seule l\'heure dans votre fuseau horaire (destinataire) est affichée.',
                'help.message_time_context.point2': 'Avec le plan PRO, l\'heure locale de l\'expéditeur, son pays et son fuseau horaire sont également affichés.',
                'help.message_time_context.point3': 'Le contexte est conservé de manière historique dans chaque message.',
                'help.message_time_context.point4': 'Les fonctions avancées d\'audit sont disponibles sur les plans supérieurs.',
                'presence.custom.title': 'Statut personnalisé',
                'presence.custom.status': 'Statut personnalisé',
                'presence.custom.placeholder': 'Ex. : Je prends un café ☕',
                'presence.custom.emoji': 'Emoji (optionnel)',
                'presence.custom.emojiHelp': 'Sélectionnez un emoji ou saisissez-en un',
                'presence.custom.temporary': 'Statut temporaire (expire automatiquement)',
                'presence.custom.expiration': 'Date d\'expiration',
                'presence.custom.expirationHelp': 'Le statut redeviendra "En ligne" à l\'expiration',
                "presence.custom.suggestions": "Suggestions argentines",
                'presence.custom.preview': 'Aperçu',
                'presence.custom.save': 'Enregistrer le statut',
                'presence.custom.required': 'Le statut personnalisé est obligatoire',
                'presence.custom.maxLength': 'Maximum 64 caractères',
                'presence.custom.expirationRequired': 'Vous devez sélectionner une date d\'expiration',
                'presence.custom.expirationFuture': 'La date d\'expiration doit être dans le futur',
                'presence.custom.selectEmoji': 'Sélectionner un emoji',
                'invitation.success.title': 'Invitation envoyée',
                'invitation.success.message': 'Invitation envoyée avec succès.\n\nLe contact recevra un e-mail avec un lien pour accepter l\'invitation. Une fois acceptée, vous pourrez commencer à discuter avec lui.',
                'invitation.top.title': 'Top des bâtisseurs de réseau',
                'invitation.top.invitesSuffix': 'invitations',
                "invitation.ranking.position": "Position",
                'invitation.ranking.user': 'Utilisateur',
                'invitation.ranking.validatedInvites': 'Invitations validées',
                'invitation.ranking.empty': 'Aucune invitation validée à afficher.',
                'invitation.ranking.loading': 'Chargement du classement...',
                'invitation.ranking.loadError': 'Impossible de charger le classement.',
                'invitations.waitBeforeResend': 'Vous ne pouvez pas encore renvoyer l\'invitation. Vous devez attendre 10 minutes entre chaque envoi pour éviter le spam.',
                'invitations.captchaQuestion': 'Combien font %1 + %2 ?',
                'invitations.resendSuccess': 'L\'invitation a été renvoyée avec succès.',
                'invitations.dailyLimit': 'Vous avez atteint le nombre maximal de renvois autorisés aujourd\'hui.',
                'invitations.invalidEmail': 'Le serveur de messagerie a indiqué que cette adresse est invalide.',
                'achievement.unlocked': 'Succès débloqué',
                'achievement.continue': 'Continuer',
                'dashboard.not_available': 'Non disponible',
                'plan.errors.chatsLimit.title': 'Limite de conversations atteinte',
                'plan.errors.chatsLimit.message': 'Votre plan actuel limite le nombre de conversations que vous pouvez avoir.',
                'plan.errors.chatsLimit.solution': 'Pour créer plus de conversations, passez au plan PRO.',
                'errors.generic': 'Une erreur inattendue est survenue. Veuillez réessayer.',
                'errors.modal.title': 'Erreur',
                'errors.modal.copyDetails': 'Copier les détails',
                'errors.modal.close': 'Fermer',
                'errors.modal.reportSupport': 'Signaler au support',
                'errors.avatarTooLarge': 'L\'image dépasse la taille maximale autorisée de 2 Mo.',
                'errors.avatarTooLarge.title': 'Image trop volumineuse',
                'errors.avatarTooLarge.message': 'L\'image dépasse la taille maximale autorisée de 2 Mo.',
                'errors.invalidImageType': 'Le fichier sélectionné n\'est pas une image valide.',
                'errors.invalidImageType.title': 'Fichier invalide',
                'errors.invalidImageType.message': 'Le fichier sélectionné n\'est pas une image valide.',
                'errors.uploadFailed': 'Impossible d\'envoyer l\'image. Veuillez réessayer.',
                'errors.uploadFailed.title': 'Erreur d\'envoi',
                'errors.uploadFailed.message': 'Impossible d\'envoyer l\'image. Veuillez réessayer.',
                'errors.conversationCreate': 'Erreur lors de la création de la conversation. Veuillez réessayer.',
                'errors.conversationInvalidId': 'ID de conversation invalide.',
                'errors.conversationOpen': 'Erreur lors de l\'ouverture de la conversation. Veuillez réessayer.',
                'errors.favoriteUpdate': 'Impossible de mettre à jour le favori',
                'errors.blockUpdate': 'Impossible de mettre à jour le blocage',
                'errors.messageEdit': 'Erreur lors de la modification du message.',
                'errors.foundation_sold_out': 'Les places Founder sont épuisées.',
                'errors.userInactive.title': 'Compte désactivé',
                'errors.tenantMismatch.title': 'Erreur de tenant',
                'auth.tagline': 'Le pouvoir d\'être compris, quelle que soit la langue',
                'auth.sign_in': 'Se connecter',
                'auth.create_account': 'Créer un compte',
                'ui.search_contact': 'Rechercher un contact...',
                'ui.language': 'Langue',
                'profile.my_profile': 'Mon profil',
                'profile.status': 'Statut',
                'profile.invite_email': 'Inviter un contact par e-mail',
                'profile.sent_invitations': 'Invitations Envoyées',
                'profile.users': 'Utilisateurs',
                'profile.settings': 'Paramètres',
                'profile.appearance': 'Apparence',
                'profile.logout': 'Déconnexion',
                "contacts.mode": "Mode",
                'contacts.sent': 'Envoyée',
                "contacts.actions": "Actes",
                'contacts.pending': 'En attente',
                "contacts.available": "Disponible",
                'contacts.invited_registered': 'Invité - Inscrit',
                'table.email': 'E-mail',
                'table.language': 'Langue',
                "table.mode": "Mode",
                'table.status': 'Statut',
                'table.sent': 'Envoyée',
                "table.actions": "Actes",
  'promotions.invite.message': 'Je t\'invite sur ArChat — parle dans n\'importe quelle langue. Nous gagnons tous les deux des avantages.',
  'promotions.progress.pending': 'Vous avez des invitations en attente pour débloquer des récompenses.',
  'promotions.progress.in_progress': 'Vos invitations sont en cours : les récompenses s\'activent après une vraie conversation.',
  'promotions.progress.remaining': 'Il vous manque {count} conversation(s) pour recevoir votre récompense.',
  'promotions.progress.sent_count': 'Envoyées',
  'promotions.progress.pending_count': 'En attente',
  'promotions.progress.in_progress_count': 'En cours',
  'promotions.progress.completed_count': 'Complétées',
  'promotions.banner.empty': 'Commencez maintenant : invitez des contacts et débloquez des avantages.',
  'promotions.banner.pending': 'Vous avez des invitations en attente : finalisez une vraie conversation et gagnez des récompenses.',
  'promotions.banner.reward': 'Vous avez déjà débloqué des récompenses ! Continuez à inviter pour augmenter vos gains.',
  'promotions.cta.copy': 'Copier le message et le lien',
  'promotions.cta.copied': 'Message copié',
  'promotions.cta.copy_error': 'Impossible de copier le message',

  'promotions.title': 'Promotions et récompenses',
  'promotions.subtitle': 'Invitez des contacts et débloquez des avantages avec une utilisation réelle.',
  'promotions.how_it_works': 'Comment ça marche',
  'promotions.step1': 'Invitez un contact depuis votre profil.',
  'promotions.step2': 'Lorsqu\'il accepte et discute avec une interaction réelle, la validation est automatique.',
  'promotions.step3': 'La récompense est créditée et votre progression est mise à jour.',
  'promotions.rewards.title': 'Récompenses',
  'promotions.reward.invite': 'Récompense pour chaque invitation validée.',
  'promotions.reward.milestone': 'Bonus pour les paliers de croissance.',
  'promotions.reward.ranking': 'Visibilité dans le classement des meilleurs créateurs de réseau.',
  'promotions.progress.title': 'Votre progression',
  'promotions.progress.sent': 'Envoyées',
  'promotions.cta.invite': 'Inviter un contact',
  'promotions.banner': 'Activez les promotions : invitez et gagnez des récompenses via une utilisation réelle.',
  'promotions.modal.title': 'Programme de promotions',
  'promotions.modal.body': 'Gagnez +10 000 caractères par invitation validée.\nInvitez dès aujourd\'hui et débloquez des récompenses.',
  'promotions.modal.cta': 'Voir les promotions',
                "app.install_ios_hint": `Pour installer : Partager > Ajouter à l'écran d'accueil`,
                "menu.promotions": "Promotions",
                "suggestions.new": "Nouvelle suggestion",
                "suggestions.empty": `Vous n'avez pas encore soumis de suggestions.`,
                "suggestions.admin_note": `Note d'équipe`,
                "suggestions.status.pending": "Boucle",
                "suggestions.status.reviewed": "Révisé",
                "suggestions.status.planned": "Prévu",
                "suggestions.status.implemented": "Mis en œuvre",
                "suggestions.status.rejected": "Rejeté",
                "referral.promo": "Invitez et gagnez 10 000 personnages",
                "referral.stats.sent": "Envoyé",
                "referral.stats.accepted": "Accepté",
                "referral.stats.rewards": "Récompenses",
                "referral.reward.pending": "Boucle",
                "referral.reward.granted": "Rempli",
                "referral.reward.invalid": "Invalide",
                "referral.reward.in_progress": "Utilisé",
                "referral.limit.reached": "Limite de récompense atteinte",
                "referral.waiting.usage": "+10 000 caractères chacun lorsque vous et votre invité envoyez au moins un vrai message texte dans le même chat (validé par le serveur).",
                "common.avatar": "Avatar",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": `Il n'y a pas encore de messages`,
                "messages.loading": "Chargement des messages...",
                "messages.connecting_server": "Connexion au serveur de messages...",
                "messages.pending_send_count": "{count} message(s) en attente de livraison",
                "presence.custom.suggestion.coffee": "Avoir des amis ☕",
                "presence.custom.suggestion.soccer": "Sur le terrain ⚽",
                "presence.custom.suggestion.working": "Travailler comme un fou 💪",
                "presence.custom.suggestion.lunch": "Je déjeune 🍽️",
                "presence.custom.suggestion.family": "Déjeuner en famille 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Étudier 📚",
                "presence.custom.suggestion.travel": "En voyage ✈️",
                "presence.custom.suggestion.meeting": "En réunion 💼",
                "presence.custom.suggestion.resting": "Repos 😴",
                "presence.custom.suggestion.gaming": "Jouer à des jeux vidéo 🎮",
                "presence.custom.suggestion.reading": "Lecture 📖",
                "presence.custom.suggestion.offlineSoon": "Je reviens tout de suite ⏳",
                "invitation.safe.phase_notice": `Phase de sécurité active : bénéfice en attente d'activation commerciale (pas d'impact réel sur les limites).`,
                "invitation.safe.generate_code": "Générer un lien/code",
                "invitation.safe.refresh_top3": "Mettre à jour le Top 3",
                "invitation.safe.top_loading": "Chargement des principaux invités...",
                "invitation.safe.top_empty": "Il n’y a pas encore d’invités en vedette.",
                "invitation.safe.hide_full_ranking": "Masquer le classement complet",
                "invitation.safe.view_full_ranking": "Voir le classement complet",
                "invitation.safe.hide_metrics_dashboard": "Masquer le tableau de bord des métriques",
                "invitation.safe.view_metrics_dashboard": "Afficher le tableau de bord des métriques",
                "invitation.safe.prepared_link": "Lien préparé",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": `Inscription en attente d'invitation`,
                "invitation.safe.status_summary": `Résumé de l'état`,
                "invitation.safe.summary.pending": `Boucles d'oreilles`,
                "invitation.safe.summary.registered": "Inscrit",
                "invitation.safe.summary.active": "Actif",
                "invitation.safe.summary.validated": "Validé",
                "invitation.safe.summary.rejected": "Rejeté",
                "invitation.safe.sent_invitations": "Invitations émises",
                "invitation.safe.table.id": "IDENTIFIANT",
                "invitation.safe.table.invited_email": "E-mail invité",
                "invitation.safe.table.code": "Code",
                "invitation.safe.table.status": "État",
                "invitation.safe.table.created": "Créé",
                "invitation.safe.empty_sent": `Aucune invitation émise pour l'instant.`,
                "invitation.safe.simulated_rewards": "Récompenses simulées gagnées",
                "invitation.safe.empty_rewards": `Aucune récompense simulée pour l'instant.`,
                "invitation.safe.error.load_status": `Impossible de charger le statut de l'invitation.`,
                "invitation.safe.error.generate_code": `Le code n'a pas pu être généré.`,
                "invitation.safe.error.invalid_email": `Entrez un e-mail valide pour enregistrer l'invitation.`,
                "invitation.safe.error.register_pending": `L'invitation en attente n'a pas pu être enregistrée.`,
                "invitation.safe.success.code_generated": "Code généré avec succès.",
                "invitation.safe.success.pending_registered": "Invitation en attente enregistrée en mode sans échec.",
                "invitation.status.deleted": "Éliminé",
                "invitation.deleted.tooltip": "Cette invitation a été supprimée",
                "invitation.status.rejected": "Rejeté",
                "invitation.status.bounced": "Rebondi",
                "invitation.status.unknown": "Statut inconnu",
                "dashboard.admin.title": "Indicateurs de croissance",
                "dashboard.admin.newUsersToday": `Nouveaux utilisateurs aujourd'hui`,
                "dashboard.admin.messagesSentToday": `Messages envoyés aujourd'hui`,
                "dashboard.admin.translationsUsed": "Traductions utilisées",
                "dashboard.admin.invitesCreated": "Invitations créées",
                "dashboard.admin.invitesValidated": "Invitations validées",
                "dashboard.admin.inviteConversion": `Conversion d'invitations`,
                "dashboard.admin.kFactor": "Facteur K",
                "dashboard.admin.newUsers": "Nouveaux utilisateurs",
                "dashboard.admin.messagesSent": "Messages envoyés",
                "dashboard.admin.noData": "Aucune donnée",
                "dashboard.admin.kFactor.viral": "Viral",
                "dashboard.admin.kFactor.stable": "Écurie",
                "dashboard.admin.kFactor.low": "Faible",
                "dashboard.admin.emailMetrics": "Métriques de courrier électronique",
                "dashboard.admin.email.sent": "Envoyé",
                "dashboard.admin.email.delivered": "Livré",
                "dashboard.admin.email.opened": "ouvrir",
                "dashboard.admin.email.clicked": "Clics",
                "dashboard.admin.email.bounced": "Rebondi",
                "dashboard.admin.email.deliveryRate": "Tarif de livraison",
                "dashboard.admin.email.openRate": `Taux d'ouverture`,
                "dashboard.admin.email.bounceRate": "taux de rebond",
                "dashboard.admin.funnelMetrics": `Métriques de l'entonnoir`,
                "dashboard.admin.funnel.registered": "Inscrit",
                "dashboard.admin.funnel.confirmed": "Confirmé",
                "dashboard.admin.funnel.loggedIn": "Première connexion",
                "dashboard.admin.funnel.firstMessage": "Premier message",
                "dashboard.admin.funnel.abandoned": "Abandonné",
                "dashboard.admin.funnel.conversionRate": "Taux de conversion",
                "dashboard.admin.funnel.activationRate": `Taux d'activation`,
                "dashboard.admin.funnel.dropoffRate": `Taux d'abandon`,
                "dashboard.admin.loading": "Chargement des métriques...",
                "dashboard.admin.errorLoad": `Le tableau de bord des métriques n'a pas pu être chargé.`,
                "dashboard.admin.growthViral": "Croissance virale",
                "dashboard.admin.growthStable": "Croissance stable",
                "dashboard.admin.growthLow": "Faible croissance",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Code",
                "errors.modal.message": "Message",
                "errors.modal.path": "Itinéraire",
                "errors.modal.time": "Heure",
                "errors.modal.timestamp": "Horodatage",
                "errors.modal.copied": "Détail copié",
                "errors.network": "Impossible de se connecter au serveur. Vérifiez votre connexion.",
                "errors.unexpected": `Une erreur inattendue s'est produite. Essayer à nouveau.`,
                "errors.boundary.title": "ERREUR DE RÉACTION CAPTURÉE",
                "errors.boundary.request_id": "ID de demande X :",
                "errors.boundary.correlate": "Mapper vers backend/logs/structured.log",
                "errors.boundary.message_label": "Message:",
                "errors.boundary.stack_trace": "Trace de pile",
                "errors.boundary.component_stack": "pile de composants",
                "errors.boundary.empty": "(vide)",
                "errors.boundary.reload_page": "Recharger la page",
                "errors.ui_boundary.refresh": `Erreur d'interface ArChat - rechargement de la page`,
                "bootstrap.error.title": "ArChat® — Erreur de démarrage",
                "common.reload": "Recharger",
                "admin.access_denied.message": "Message",
                "admin.access_denied.title": "Titre",
                "admin.action.change_plan": "Changer de forfait",
                "admin.action.reactivate": "Réactiver",
                "admin.action.suspend": "Suspendre",
                "admin.action.view": "Voir",
                "admin.confirm.change_plan.message": "Message",
                "admin.confirm.change_plan.title": "Titre",
                "admin.confirm.suspend.message": "Message",
                "admin.confirm.suspend.title": "Titre",
                "admin.details.created": "Créé",
                "admin.details.current_plan": "Forfait actuel",
                "admin.details.domain": "Domaine",
                "admin.details.last_activity": "Dernière activité",
                "admin.details.name": "patate douce",
                "admin.details.plan": "Plan",
                "admin.details.status": "Statut",
                "admin.details.subscription": "Abonnement",
                "admin.details.tenant_id": "ID du locataire",
                "admin.details.tenant_info": "Informations locataire",
                "admin.details.usage": "Usage",
                "admin.error.change_plan": "Changer de forfait",
                "admin.error.generic": "Générique",
                "admin.error.load_details": "Charger les détails",
                "admin.error.load_tenants": "Charger les locataires",
                "admin.error.reactivate": "Réactiver",
                "admin.error.suspend": "Suspendre",
                "admin.error.title": "Titre",
                "admin.filter.active": "Activer",
                "admin.filter.all_plans": "Tous les forfaits",
                "admin.filter.all_status": "Tous les statuts",
                "admin.filter.suspended": "Suspendre",
                "admin.limit.devices": "Appareils",
                "admin.limit.invitations": "Invitations",
                "admin.limit.messages": "messages",
                "admin.limit.storage": "Stockage",
                "admin.limit.users": "Utilisateurs",
                "admin.loading": "Chargement",
                "admin.no_tenants": "Non-locataires",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Activer",
                "admin.status.suspended": "Suspendre",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Dernier paiement",
                "admin.subscription.status": "Statut",
                "admin.subtitle": "Sous-titre",
                "admin.success.plan_changed": "Plan modifié",
                "admin.success.tenant_reactivated": "Locataire réactivé",
                "admin.success.tenant_suspended": "Locataire suspendu",
                "admin.success.title": "Titre",
                "admin.table.actions": "Actes",
                "admin.table.messages": "messages",
                "admin.table.name": "patate douce",
                "admin.table.plan": "Plan",
                "admin.table.status": "Statut",
                "admin.table.storage": "Stockage",
                "admin.table.tenant_id": "ID du locataire",
                "admin.table.users": "Utilisateurs",
                "admin.title": "Titre",
                "admin.usage.devices": "Appareils",
                "admin.usage.invitations": "Invitations",
                "admin.usage.messages": "messages",
                "admin.usage.storage": "Stockage",
                "admin.usage.users": "Utilisateurs",
                "auth.login": "Se connecter",
                "auth.register": "Registre",
                "auth.reset_password": "réinitialiser le mot de passe",
                "billing.cancel.button": "bouton",
                "billing.cancel.canceling": "Annulation",
                "billing.cancel.confirm": "Confirmer",
                "billing.cancel.error": "Erreur",
                "billing.cancel.success": "succès",
                "billing.character_billing.characters_used": "Caractères utilisés",
                "billing.character_billing.consumption_pct": "PCT de consommation",
                "billing.character_billing.days_remaining": "Jours restants",
                "billing.character_billing.deletion_date": "Date de suppression",
                "billing.character_billing.period_start": "Début des règles",
                "billing.character_billing.renewal_date": "Date de renouvellement",
                "billing.character_billing.title": "Titre",
                "billing.current_plan": "Forfait actuel",
                "billing.founder_badge": "Insigne de fondateur",
                "billing.no_plans": "Ne planifie pas",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "Prochain paiement",
                "billing.subscription.plan": "Plan",
                'billing.subscription.price': 'Prix du plan',
                "billing.subscription.started": "Commencé",
                "billing.subscription.status": "Statut",
                "billing.subscription.mp_flow.subscribe_failed": `L'abonnement n'a pas pu démarrer. Essayer à nouveau.`,
                "billing.subscription.mp_flow.change_plan_failed": "Le plan ne pouvait pas être modifié. Essayer à nouveau.",
                "billing.subscription.mp_status.pending": "Boucle",
                "billing.subscription.mp_status.authorized": "Autorisé",
                "billing.subscription.mp_status.active": "Actif",
                "billing.subscription.mp_status.paused": "En pause",
                "billing.subscription.mp_status.cancelled": "Annulé",
                "billing.subscription.mp_status.inactive": "Inactif",
                "billing.subscription.mp_status.unknown": "Un étranger",
                "billing.unlimited": "Illimité",
                "billing.update_plan": "Plan de mise à jour",
                "billing.update_plan_modal.title": "Titre",
                "billing.usage.loading": "Chargement",
                "common.accept": "Accepter",
                "common.confirmPassword": "Confirmez le mot de passe",
                'common.continue': 'Continuer',
                "common.error": "Erreur",
                "dashboard.upgrade.to_plan": "Planifier",
                "emoji.noResults": "Aucun résultat",
                "emoji.pick": "Prendre",
                "export.restricted.message": "Message",
                "export.restricted.title": "Titre",
                "export.restricted.upgrade": "Mise à niveau",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "T1",
                "help.faq.q2": "T2",
                "help.faq.q3": "T3",
                "help.faq.q4": "T4",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "Titre",
                "help.howWorks.step4.point7": "Point7",
                "help.message_time_context.free_vs_pro": "Gratuit ou professionnel",
                "help.message_time_context.point5": "Point5",
                "help.plans.enterprise.benefits": "Avantages",
                "help.plans.enterprise.description": "Description",
                "help.plans.enterprise.title": "Titre",
                "help.plans.foundation.devices": "Appareils",
                "help.plans.free.description": "Description",
                "help.plans.free.devices": "Appareils",
                "help.plans.free.limits": "Limites",
                "help.plans.free.title": "Titre",
                "help.plans.intro": "Introduction",
                "help.plans.pro.benefits": "Avantages",
                "help.plans.pro.description": "Description",
                "help.plans.pro.devices": "Appareils",
                'help.plans.pro.price': '$19 / mois',
                "help.plans.pro.title": "Titre",
                "help.plans.pro.upgrade": "Mise à niveau",
                "help.plans.title": "Titre",
                "help.plans.urgent_slots_badge": "Badge de créneaux urgents",
                "help.slogan.final": "Fin",
                "help.suggestions.point1": "Point1",
                "help.suggestions.point2": "Point2",
                "help.suggestions.title": "Titre",
                "invitation.already_contact_added": "Contact déjà ajouté",
                "invitation.already_contact_title": "Titre déjà contacté",
                "invitation.already_pending": "Déjà en attente",
                "invitation.language.invalid": "Invalide",
                "message.send": "Envoyer",
                "message.sendFile": "Envoyer un fichier",
                "messages.conversations": "Conversations",
                "messages.no_conversations_subtitle": "Pas de sous-titre de conversations",
                "messages.no_conversations_title": "Aucun titre de conversation",
                "presence.custom.edit": "Modifier",
                "profile.enrichment.country": "pays",
                "profile.enrichment.country.select": "Sélectionner",
                "profile.enrichment.description": "Description",
                "profile.enrichment.org_size": `Taille de l'organisation`,
                "profile.enrichment.org_size.placeholder": "espace réservé",
                "profile.enrichment.save": "Sauvegarder",
                "profile.enrichment.skip": "sauter",
                "profile.enrichment.title": "Titre",
                "profile.enrichment.usage_type.label": "Étiquette",
                "profile.enrichment.usage_type.placeholder": "espace réservé",
                "profile.founderPosition": "Poste de fondateur",
                "settings.confirmations.description": "Description",
                "settings.confirmations.disable": "Désactiver",
                "settings.confirmations.title": "Titre",
                "settings.confirmations.updated": "Mis à jour",
                "settings.title": "Titre",
                "theme.description": "Description",
                "google.unavailable_tenant": `Google n'est pas disponible pour ce locataire.`,
                "google.unavailable": "Google indisponible.",
                "google.verify_client_id": `Vérifiez l'ID client dans Google Cloud Console.`,
                'google.login_aria': 'Se connecter avec Google',
                "message.preview_alt": "Aperçu",
                "message.image_attachment_alt": "Image ci-jointe",
                "profile.avatar.alt": "avatar",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Chargement des principaux invités...",
                "invitation.top.empty": `Aucun invité en vedette pour l'instant.`,
                "invitation.contacts.title": "Inviter des contacts",
                "invitation.contacts.safe_phase_note": "Phase sécurisée active : bénéfices en attente sans impact sur les limites réelles.",
                "invitation.contacts.generate_code": "Générer du code/lien",
                "invitation.contacts.refresh_top3": "Actualiser le Top 3",
                "invitation.contacts.hide_full_ranking": "Masquer le classement complet",
                "invitation.contacts.show_full_ranking": "Afficher le classement complet",
                "invitation.contacts.hide_metrics_dashboard": "Masquer le tableau de bord des métriques",
                "invitation.contacts.show_metrics_dashboard": "Afficher le tableau de bord des métriques",
                "invitation.contacts.prepared_link_label": "Lien préparé :",
                "invitation.contacts.email_placeholder": "email@domaine.com",
                "invitation.contacts.register_pending": `Inscription en attente d'invitation`,
                "invitation.contacts.status_summary": `Résumé de l'état`,
                "invitation.contacts.sent_invitations": "Invitations envoyées",
                "invitation.contacts.invited_email": "E-mail invité",
                "invitation.contacts.code": "code",
                "invitation.contacts.no_sent_invitations": `Je n'ai pas encore envoyé d'invitations.`,
                "invitation.contacts.simulated_rewards": "Récompenses simulées obtenues",
                "invitation.contacts.no_simulated_rewards": `Aucune récompense simulée pour l'instant.`,
                "common.id": "IDENTIFIANT",
                "common.created": "Créé",
                'plan.pro_contacts': 'Jusqu\'à 100 contacts par utilisateur',
                "common.status": "Statut",
                "login.prompt_create_account_with_name": "Voulez-vous créer un compte avec ce nom ?",
                'plans.upgrade.title': 'Mettre à niveau le plan',
                'plans.upgrade.comparison': 'Comparaison des plans',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Annulez quand vous voulez',
                'plans.actions.upgrade_pro': 'Passer à PRO',
                'plans.actions.become_founder': 'Devenir Fondateur',

                'plans.modal.card.current_badge': 'Votre forfait actuel',

                'plans.modal.card.lower_tier': 'En dessous de votre forfait actif',

                'plans.modal.card.manage_in_profile': 'Pour modifier ou résilier : Abonnement et facturation dans votre profil.',
                'plans.modal.card.cancel_subscription': 'Annuler l’abonnement',
                'plans.modal.cancel_confirm.title': 'Annuler ou gérer l’abonnement',
                'plans.modal.cancel_confirm.body': 'Un nouvel onglet ouvrira le portail sécurisé Paddle pour mettre à jour le paiement, les factures ou annuler l’abonnement.',
                'plans.modal.cancel_confirm.continue_button': 'Continuer',
                'plans.modal.cancel_confirm.back_button': 'Retour',
                'plans.modal.cancel_paddle_fallback.title': 'Gérer votre abonnement',
                'plans.modal.cancel_paddle_fallback.body': 'Le portail de facturation Paddle ne s’ouvre pas dans cet environnement (ex. développement local ou compte pas encore lié). Vous pouvez continuer à consulter et comparer les offres ici.',
                'plans.modal.cancel_paddle_fallback.confirm': 'D\'accord',
                'plans.upgrade_required': 'Disponible avec le plan PRO',
                'settings.heading': 'Paramètres',
                'settings.dashboard': 'Tableau de bord',
                'settings.dashboardDescription': 'Préférences locales du tableau d’accueil et des blocs visibles.',
                'settings.dashboardGridHeading': 'Blocs du tableau',
                'settings.dashboardShowOnStartDescription': 'Si activé, le tableau s’ouvre à la connexion à la place de la liste de contacts.',
                'settings.dashboardBlockWelcome': 'Bienvenue',
                'settings.dashboardBlockUsage': 'Utilisation du plan',
                'settings.dashboardBlockFiles': 'Mes fichiers',
                "settings.dashboardBlockPromotions": "Promotions",
                "settings.dashboardBlockSessions": "Séances actives",
                'settings.dashboardWelcomeDescription': 'Premiers pas, invitation et raccourcis d’aide.',
                'settings.dashboardUsageDescription': 'Utilisation par rapport aux limites : contacts, caractères, stockage, appareils.',
                'settings.dashboardFilesDescription': 'Résumé des fichiers visibles et de l’espace (Mes fichiers).',
                'settings.dashboardPromotionsDescription': 'Résumé des promotions et lien vers le programme.',
                'settings.dashboardSessionsDescription': 'Sessions et appareils actifs ; possibilité de fermer les autres si disponible.',
                'settings.enabled': 'Activé',
                'settings.disabled': 'Désactivé',
                'settings.showDashboardOnStart': 'Afficher le tableau de bord à la connexion',
                'settings.showWelcomeBlock': 'Afficher le bloc d’accueil',
                'settings.showPromotionsBlock': 'Afficher le bloc promotions',
                'settings.showUsageBlock': 'Afficher l’utilisation du forfait',
                'settings.showRecentConversationsBlock': 'Afficher les conversations récentes (dernier message par contact)',
                'settings.showSessionsBlock': 'Afficher les sessions actives',
                'settings.showFilesBlock': 'Afficher le résumé des fichiers',
                'settings.dashboardLocalNote': 'Ces préférences sont stockées dans ce navigateur (local) en attendant une API de profil.',
                'settings.appearanceSettings': 'Apparence',
                'settings.argentinaTheme': 'Thème Argentine',
                'settings.darkMode': 'Mode sombre',
                'settings.language': 'Langue',
                'settings.messageSound': 'Son des messages',
                'settings.playSoundDescription': 'Jouer un son pour les nouveaux messages ou les alertes importantes.',
                'settings.messageSoundEnabled': 'Activé',
                'settings.messageSoundDisabled': 'Désactivé',
                'settings.accountSettings': 'Compte',
                'settings.deleteAccount': 'Supprimer le compte',
                'settings.deleteAccountWarning': 'Cette action est définitive. Vos données, messages, contacts et paramètres seront supprimés conformément au processus de la plateforme.',
                'settings.deleteMyAccount': 'Supprimer mon compte',
                "dashboard.contacts": "Contacts",
                'dashboard.characters': 'Caractères',
                'dashboard.storage': 'Stockage',
                'dashboard.active_devices': 'Appareils actifs',
                'dashboard.need_more_resources': 'Besoin de plus de ressources ?',
                'dashboard.upgrade_message': 'Mettez à niveau votre plan pour obtenir plus de contacts, de caractères, de stockage et d\'appareils actifs.',
                'dashboard.upgrade_button': 'Passer à PRO',
                'dashboard.upgrade_button_pro': 'Passer à PRO',
                'dashboard.upgrade_button_foundation': 'Passer à FOUNDATION',
                'files.preview': 'Aperçu',
                'files.previewFile': "Aperçu du fichier",
                'files.previewUnavailable': "L'aperçu n'est pas disponible.",
                'files.previewLoading': "Chargement de l'aperçu…",
                'files.openPreview': 'Aperçu',
                'files.downloadFile': 'Télécharger le fichier',
                'files.downloadFailed': 'Le fichier n’a pas pu être téléchargé. Vérifiez la connexion et la session, puis réessayez.',
                'files.closePreview': "Fermer l'aperçu",
                'files.unsupportedPreview': "Aucun aperçu pour ce type de fichier. Vous pouvez lire les informations ou télécharger.",
                'files.pdfPreviewHelp': "Votre navigateur peut ne pas afficher le PDF intégré. Utilisez le bouton Télécharger.",
                "files.labelFileType": "Gars",
                'files.previewForbidden': "Vous n'avez pas la permission d'afficher l'aperçu.",
                'files.previewNotFound': "Fichier indisponible ou plus visible dans votre compte.",
                'files.unavailableForFree': '« Mes fichiers » n’est pas inclus dans l’offre FREE.',
                'files.availableInFoundationAndPro': '« Mes fichiers » est disponible avec FOUNDATION et PRO.',
                'files.filesFeatureRestricted': 'Cette fonctionnalité n’est pas disponible avec votre offre actuelle.',
                'files.filesLoadError': 'Erreur lors du chargement des fichiers.',
                'files.uploadUnavailableForFree': "L'envoi de fichiers n'est pas disponible avec le plan FREE.",
                'files.uploadAvailableInFoundationAndPro': "L'envoi de fichiers est disponible avec FOUNDATION et PRO.",
                'files.recipientStorageFull': "Le destinataire n'a pas d'espace disponible pour recevoir ce fichier.",
                'files.recipientNoAvailableStorage': "Le destinataire n'a pas d'espace disponible pour recevoir ce fichier.",
                'files.storageQuotaExceeded': 'Vous avez atteint la limite de stockage de votre offre.',
                'files.freeStorageLimit': "Le plan FREE inclut 5 Mo de stockage pour les fichiers reçus.",
                'settings.unreadEmailReminderSection': 'Résumé e-mail des non lus',
                'settings.unreadEmailReminderDescription': 'Si vous laissez de nouveaux messages ou fichiers non lus plus longtemps que le délai ci-dessous, ArChat envoie un seul e-mail récapitulatif (pas un par message).',
                'settings.unreadEmailReminderToggle': 'M’envoyer des résumés par e-mail',
                'settings.unreadEmailDelayHours': 'Délai avant envoi (heures)',
                'settings.unreadEmailDelayHint': '1 à 168 heures (7 jours max.). L’e-mail utilise la langue du profil.',
                'subjects.title': 'Sujets',
                'subjects.singular': 'Sujet',
                'subjects.plural': 'Sujets',
                'subjects.general': 'Général',
                'subjects.new': 'Nouveau sujet',
                'subjects.create': 'Créer un sujet',
                'subjects.rename': 'Renommer',
                'subjects.finish': 'Terminer',
                'subjects.reopen': 'Rouvrir',
                'subjects.select': 'Continuer',
                'subjects.status.open': 'Ouvert',
                'subjects.status.pending': 'En attente',
                'subjects.status.finished': 'Terminé',
                'subjects.limitReached': 'Vous avez atteint la limite de sujets actifs pour cette conversation. Terminez un sujet pour en créer un autre.',
                'subjects.limitReachedFree': 'Le forfait FREE autorise jusqu’à 3 sujets actifs par conversation. Terminez un sujet pour en créer un autre.',
                'subjects.limitReachedPro': 'Le forfait PRO autorise jusqu’à 5 sujets actifs par conversation. Terminez un sujet pour en créer un autre.',
                'subjects.limitReachedFoundation': 'Le forfait FOUNDATION autorise jusqu’à 5 sujets actifs par conversation. Terminez un sujet pour en créer un autre.',
                'subjects.activeLimitsLine': 'Sujets actifs : {current} / {max}',
                'subjects.closedListTitle': 'Sujets fermés',
                'subjects.viewClosed': 'Voir les sujets fermés',
                'subjects.noClosedSubjects': 'Il n’y a aucun sujet fermé.',
                'subjects.reopenSubject': 'Rouvrir',
                'subjects.reopenedSubjects': 'Sujets rouverts',
                "subjects.reopenLimitReached": "Vous avez atteint la limite de problèmes actifs. Finalisez une autre affaire pour rouvrir celle-ci.",
                'subjects.ownerOnlyReopen': 'Seule la personne qui a créé ce sujet peut le rouvrir.',
                'subjects.modal.title': 'Sujets de la conversation',
                'subjects.modal.subtitle': 'Choisissez ou gérez les sujets de cette conversation.',
                'subjects.contactLabel': 'CONTACT :',
                'subjects.ownerOnlyRename': 'Seule la personne qui a créé ce sujet peut le renommer.',
                'subjects.ownerOnlyStateChange': 'Seule la personne qui a créé ce sujet peut modifier son statut.',
                'subjects.createdByOther': 'Ce sujet a été créé par l’autre partie. Vous pouvez répondre, mais pas le renommer.',
                'subjects.empty': 'Aucun sujet à afficher.',
                'subjects.noResults': 'Aucun sujet trouvé.',
                'subjects.error.generic': 'Impossible de terminer l’action. Réessayez.',
                'subjects.error.featureDisabled': 'Les sujets ne sont pas disponibles dans cet environnement.',
                'subjects.error.duplicateName': 'Un sujet actif porte déjà ce nom.',
                'subjects.error.ownerRequired': 'Vous n’avez pas la permission de modifier ce sujet.',
                'subjects.error.defaultCannotRename': 'Le sujet Général ne peut pas être renommé.',
                'subjects.error.defaultCannotFinish': 'Le sujet Général ne peut pas être terminé.',
                'subjects.current': 'Sujet',
                'subjects.change': 'Changer de sujet',
                'subjects.currentLabel': 'Sujet :',
                'subjects.changeSubject': 'Changer de sujet',
                'subjects.closedCannotSend': 'Ce sujet est terminé. Rouvrez-le pour envoyer de nouveaux messages.',
                'subjects.selectBeforeSend': 'Choisissez un sujet dans la fenêtre pour afficher les messages et envoyer.',
                'subjects.loadingMessages': 'Chargement des messages pour ce sujet…',
                'subjects.messageFilterError': 'Impossible de charger les messages pour ce sujet.',

                // Tags
                "tags.etiquetas": "balises",
                "tags.manageTitle": "Gérer les balises",
                "tags.manage": "🏷️ Balises",
                "tags.allTags": "Toutes les balises",
                "tags.confirmDelete": "Supprimer cette balise ?",
                "tags.tagNamePlaceholder": "Nom de la balise",
                "tags.create": "Créer",
                "tags.noTags": "Aucune balise. Créez-en un ci-dessus.",
                "tags.save": "Sauvegarder",
                "tags.edit": "Modifier",
                "tags.delete": "Supprimer",
                "tags.assignTo": "Attribuer à",
                "tags.noTagsToAssign": "Aucune balise disponible. Créez-les d’abord.",
                // Templates
                "templates.selectTitle": "Modèles",
                "templates.noTemplates": "Aucun modèle. Créez-en un ci-dessus.",
                "templates.manage": "Gérer les modèles",
                "templates.confirmDelete": "Supprimer ce modèle ?",
                "templates.manageTitle": "Gérer les modèles",
                "templates.titlePlaceholder": "Titre du modèle",
                "templates.bodyPlaceholder": "Écrivez le modèle de message...",
                "templates.create": "Créer un modèle",
                "templates.save": "Sauvegarder",
                "templates.edit": "Modifier",
                "templates.delete": "Supprimer",
                // Tags (added)
                "tags.bgColor": "Couleur de fond",
                "tags.textColor": "Couleur du texte",
                "tags.selectTag": "Sélectionnez une balise",
                // Web Push notifications
                "settings.webPushSection": "Notifications système (Web Push / PWA)",
                "settings.webPushDescription": "Permet des alertes lorsque l'application est en arrière-plan ou fermée sur mobile. Nécessite la clé publique VAPID dans la build (VITE_VAPID_PUBLIC_KEY) et les clés du serveur. Accorde l'autorisation du navigateur et enregistre cet appareil.",
                "settings.webPushButton": "Activer les notifications push",
                "settings.webPushRegistering": "Enregistrement…",
                "settings.webPushState.granted": "Autorisation accordée. Si VAPID est configuré, l'abonnement a été envoyé au serveur.",
                "settings.webPushState.denied": "Autorisation refusée. Activez les notifications pour ce site dans les paramètres du navigateur.",
                "settings.webPushState.default": "Appuyez sur le bouton pour demander l'autorisation et enregistrer cet appareil.",
                "settings.webPushState.unsupported": "Ce navigateur ne prend pas en charge Web Push.",
                "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY est manquant dans cette version frontend : l'abonnement push ne peut pas se terminer.",
                ...PRESET_LOCALES.fr,
                "auth.login.clear_password_lock_after_reset": "J'ai déjà modifié mon mot de passe (par exemple sur un autre appareil)",
                "auth.signup_disabled": "L'enregistrement d'un nouveau compte est temporairement désactivé dans cet environnement.",
                "auth.reset_user_not_found": "Nous n'avons trouvé aucun compte associé à cet e-mail. Vérifiez qu'il est correctement orthographié ou créez un nouveau compte.",
                "account.not_found": "Compte introuvable.",
                "auth.pending_activation.title": "Compte en attente d'activation",
                "auth.pending_activation.body": "Votre compte n'est pas encore activé. Vérifiez votre courrier électronique et confirmez votre inscription pour accéder à ArChat.",
                "auth.pending_activation.back_to_login": "Revenir à la connexion",
                "auth.pending_activation.support_prefix": "Avez-vous besoin d'aide ? Contacter l'assistance :",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "E-mail pour renvoyer l'activation",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "Entrez l'e-mail avec lequel vous vous êtes inscrit pour renvoyer l'activation.",
                "auth.pending_activation.sent_title": "E-mail d'activation envoyé",
                "auth.pending_activation.sent_body": "Si l'email correspond à un compte en attente, nous vous enverrons un nouveau lien d'activation. Vérifiez votre boîte de réception ainsi que vos spams ou courriers indésirables.",
                "auth.pending_activation.soft_error_title": "Renvoyer non disponible",
                "auth.pending_activation.soft_error_body": "Nous n'avons pas pu traiter le renvoi pour le moment. Réessayez dans quelques minutes ou écrivez-nous à info@archat.com.ar.",
                "auth.pending_activation.resend_again": "Renvoyer à nouveau",
                "menu.plans": "Forfaits",
                "files.title": "mes fichiers",
                "files.filter_all": "Tous",
                "files.filter_sent": "Envoyé",
                "files.filter_received": "Reçu",
                "files.filter_images": "Images",
                "files.filter_documents": "Documents",
                "files.col_name": "Nom",
                "files.col_size": "Taille",
                "files.col_date": "Date",
                "files.col_direction": "Réal.",
                "files.col_actions": "Actes",
                "files.sent": "📤 Envoyé",
                "files.received": "📥 Reçu",
                "files.download": "Décharge",
                "files.delete_for_me": "Supprimer pour moi",
                "files.delete_confirm_title": "Supprimer le fichier",
                "files.delete_confirm_message": "Ce fichier sera supprimé de votre compte. Il ne sera pas supprimé pour l’autre personne. Continuer?",
                "files.empty": "Vous n'avez pas de fichiers.",
                "files.error_loading": "Erreur lors du téléchargement des fichiers.",
                "files.load_more": "Charger plus",
                "message.status.sending": "Envoi…",
                "message.status.failed": "Non envoyé",
                "message.status.sent": "Envoyé",
                "message.status.delivered": "Livré",
                "message.status.read": "Lire",
                "home.public_nav.pricing": "Tarifs",
                "home.public_nav.aria": "Navigation sur le site principal",
                "home.public_footer.aria": "Liens juridiques",
                "home.pricing_link": "Forfaits et tarifs",
                "publicPricing.nav.back_home": "← Accueil",
                "publicPricing.title": "Forfaits et tarifs",
                "publicPricing.subtitle": "Limites transparentes et alignées du moteur d'abonnement ArChat. Prix ​​commerciaux en USD pour les paiements internationaux (par exemple Paddle).",
                "publicPricing.commercial_note": "Les limites fonctionnelles proviennent de PlanConstants/PlanResolver ; votre compte peut appliquer plan_limits dans la base de données. La facturation par le commerçant utilise Paddle (ou d'autres processeurs officiellement désignés par ArChat) avec une tarification en USD comme indiqué.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "Mêmes limites techniques que PRO (contrat premium).",
                "publicPricing.same_limits_foundation": "Mêmes limites techniques que FOUNDATION (contrat premium).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30 000 caractères par mois et par compte.",
                "publicPricing.free.b2": "Jusqu'à 2 contacts par utilisateur ; jusqu'à 2 conversations actives par compte.",
                "publicPricing.free.b3": "Pas de pièces jointes ni d'espace de stockage ; sans exportation de données.",
                "publicPricing.free.b4": "Historique des messages jusqu'à 30 jours ; 1 appareil par utilisateur.",
                "publicPricing.free.b5": "34 messages/jour et 1 000 messages/mois (locataire) ; jusqu'à 20 invitations par jour.",
                "publicPricing.premium.b1": "300 000 caractères par mois et par compte ; jusqu'à 100 contacts par utilisateur.",
                "publicPricing.premium.b2": "Conversations et chats illimités (locataire); 1 667 messages/jour et 50 000/mois.",
                "publicPricing.premium.b3": "Jusqu'à 50 Mo de stockage (locataire) ; jusqu'à 3 appareils par utilisateur.",
                "publicPricing.premium.b4": "Invitations illimitées (locataire); export, traduction automatique et fichiers selon plan.",
                "publicPricing.premium.b5": "FONDATION : même contrat technique que PRO, plus programme Fondateur (150 places). PRO : standard haut de gamme.",
                "publicPricing.foundation.founder_note": "Programme commercial fondateur : nombre limité de {slots} places (voir résumé du plan). Mêmes limites PRO une fois l’abonnement activé.",
                "publicPricing.cta.start_free": "Créer un compte gratuit",
                "publicPricing.cta.register_paid": "Créer un compte",
                "publicPricing.paddle_hint": "Le paiement avec le processeur choisi sera effectué dans l'application lorsque le chargement sera activé.",
                "publicPricing.legal.nav_label": "Légal",
                "publicPricing.legal.terms": "Conditions d'utilisation",
                "publicPricing.legal.privacy": "politique de confidentialité",
                "publicPricing.legal.refund": "Politique de remboursement",
                "profile.security.privacy_note": "Gérez la confidentialité et la sécurité de votre compte.",
                "profile.security.sessions_title": "Séances actives",
                "profile.security.current": "Session en cours",
                "profile.plan.foundation.description": "Plan FOUNDATION (Founder) : même utilisation premium que PRO, avec programme Founder et espace limité (150 places).",
                "billing.view_plans": "Voir les forfaits",
                "billing.paddle.cancel_via_portal": "Annuler l'abonnement",
                "billing.paddle.test_access_denied_body": "Sur ce serveur, les opérations de facturation sont restreintes (mode test ou liste de tests). Si vous avez déjà payé avec un compte réel, en production, le paiement doit être autorisé pour tous les utilisateurs (par exemple PAYMENTS_ALLOW_ALL_BILLING_USERS) ou cette restriction doit être désactivée. Contactez l'assistance.",
                "attachment.storage_insufficient_precheck.title": "Espace insuffisant",
                "attachment.storage_insufficient_precheck.message": "Le fichier pèse {fileSizeMb} Mo et vous ne disposez que de {availableMb} Mo disponibles. Libérez de l'espace ou améliorez votre plan pour continuer.",
                "attachment.files_disabled.title": "Limite du forfait",
                "attachment.files_disabled.message": "Votre forfait actuel n'inclut pas l'envoi de fichiers. Améliorez votre plan pour continuer.",
                "contacts.viewContactInfo": "Afficher les coordonnées",
                "contacts.contactInfoTitle": "Coordonnées",
                "contacts.phone": "Téléphone",
                "contacts.bio": "Biographie",
                "contacts.notProvided": "Mal informé",
                "contacts.unread.badge": "Messages non lus",
                "dashboard.recentInbound.title": "Derniers messages reçus",
                "dashboard.recentInbound.empty": "Vous n'avez reçu aucun message récemment.",
                "dashboard.recentInbound.error": "Les messages n'ont pas pu être chargés.",
                "dashboard.recentInbound.previewPhoto": "Photo",
                "dashboard.recentInbound.previewFile": "Archive",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "Message non disponible",
                "dashboard.recentInbound.readTitle": "Lire",
                "dashboard.recentInbound.unreadTitle": "non lu",
                "dashboard.recentConversations.title": "Conversations récentes",
                "dashboard.recentConversations.empty": "Il n'y a aucune conversation à afficher.",
                "dashboard.recentConversations.error": "Les conversations n'ont pas pu être chargées.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "Traduction non disponible",
                "plan.errors.translationNotAllowed.message": "Votre forfait actuel n'inclut pas la traduction automatique entre les langues.",
                "plan.errors.translationNotAllowed.solution": "Pour utiliser la traduction automatique, mettez à niveau votre forfait.",
                "billing.subscription.cancel_scheduled_date": "Votre abonnement devrait être annulé le {{date}}. Vous pouvez continuer à utiliser votre forfait d’ici là.",
                "billing.subscription.cancel_scheduled_badge": "Annulé le {{date}}",
                "billing.scheduled.plan_after_cancel_label": "Plan en fin de période :",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "Passer à FONDATION",
                "billing.scheduled.switch_to_free": "Passer à GRATUIT",
                "billing.scheduled.foundation_full_title": "FONDATION non disponible",
                "billing.scheduled.foundation_full_message": "Il n’y a pas de places FOUNDATION disponibles pour le moment. Votre forfait deviendra GRATUIT à la fin de la période.",
                "billing.scheduled.saving": "Économie...",
                "billing.scheduled.error_title": "Erreur lors du changement de forfait",
                "billing.scheduled.error_generic": "Le plan prévu n'a pas pu être modifié. Essayer à nouveau.",
                "billing.cancel_scheduled.title": "Annulation programmée",
                "billing.cancel_scheduled.desc": "Votre abonnement sera annulé le {{date}}. Vous pouvez continuer à utiliser votre forfait actuel d’ici là.",
                "billing.cancel_scheduled.no_new_plan_until_end": "Jusqu'à l'expiration de cet abonnement, vous ne pourrez pas souscrire à un autre forfait.",
                "billing.cancel_scheduled.free_fallback": "Si vous ne renouvelez aucun forfait, votre compte continuera GRATUITEMENT avec les limitations correspondantes.",
                "billing.cancel_scheduled.profile_deactivation_hint": "Vous pouvez également vous désinscrire de la plateforme depuis votre profil.",
                "billing.cancel_scheduled.default_free": "En fin de période : GRATUIT",
                "google.missing_client_id": "Google Sign-in n'est pas disponible dans cette version : VITE_GOOGLE_CLIENT_ID (ou googleClientId par locataire dans __ARCHAT_TENANT_CONFIG__) est manquant.",
                "reviews.title": "Avis sur ArChat",
                "reviews.create_title": "Comment évalueriez-vous ArChat ?",
                "reviews.edit_title": "Modifier mon avis",
                "reviews.comment_placeholder": "Parlez-nous de votre expérience (facultatif)...",
                "reviews.submit_btn": "Envoyer l'avis",
                "reviews.update_btn": "Mise à jour",
                "reviews.thank_you": "Merci pour votre avis !",
                "reviews.submitted_message": "Votre avis nous aide à nous améliorer.",
                "reviews.error_select_rating": "Sélectionnez une note",
                "reviews.error_generic": "Erreur lors de l'envoi de l'avis",
                "reviews.prompt_message": "Aimez-vous ArChat? Laissez votre avis !",
                "reviews.rate_now": "Qualifier",
                "reviews.later": "Plus tard",
                "reviews.write_review": "Écrire un avis",
                "reviews.edit_my_review": "Modifier mon avis",
                "reviews.no_reviews": "Il n'y a pas encore d'avis. Soyez le premier !",
                "reviews.review_singular": "revoir",
                "reviews.review_plural": "avis",
                "reviews.verified": "Vérifié",
                "reviews.anonymous": "Anonyme",
                "files.storageUsed": "Espace utilisé",
                "files.planQuota": "Quotas du plan",
                "files.availableStorage": "Disponible",
                "files.usagePercent": "utilisé",
                "files.unlimited": "Illimité",
                "files.sentBy": "Envoyé par",
                "files.unknownUser": "Utilisateur",
};


